//#region "Import"
import React, { useState, useEffect, useMemo, useCallback, useContext} from 'react';
import { IonHeader, IonItem, IonLabel, IonSelect, IonSelectOption, IonLoading, IonAlert, IonInput, IonToggle, IonButton, IonDatetime, IonSegment, 
         IonSegmentButton, IonIcon, IonModal, IonList, IonRadioGroup, IonRadio, IonCheckbox, IonText, IonGrid, IonCol, IonRow, IonContent, 
         IonToast, IonFab, IonFabButton, IonImg, IonTextarea} from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import { usePhotoGallery, Photo } from '../hooks/usePhotoGallery';
import { AppContext, AppContextInterface } from '../AppContext';
import { RouteParams } from '../domain/RouteParams';
import { DataAccessService } from '../services/dataAccessService';
import { getCondition, getBoatForPerson, getPersonForBoat } from '../services/asyncDataService';
import { IActivityLogResult, IActivityLogResult_Response, IEquipmentInspectionPointInfo, EquipmentInspectionPointInfo,
         IGARInfo, GARInfo, IViolationInfo, ViolationInfo, ISafetyCheckItem, SafetyCheckItem, IActivityPhotoItem, 
         ILocalIdentifier, ILocalIdentifierPerson } from '../domain/ActivityLog';
import { IActivityLogRoleInfo } from '../domain/ActivityLogRole';
import { ISeasInfo } from '../domain/Seas';
import { IWindInfo } from '../domain/Wind';
import { IWeatherInfo } from '../domain/Weather';
import { IConditionInfo, ICondition_Response } from '../domain/Condition';
import { IEquipmentInfo,  IEquipmentStatusInfo, IEquipmentInspectionPointItem, IEquipmentTypeInfo, IEquipment_Response } from '../domain/Equipment';
import { IIncidentDispositionInfo } from '../domain/IncidentDisposition';
import { IDeliveryMethodInfo } from '../domain/DeliveryMethod';
import { IPersonInfo, IPerson_Request, IPerson_Response } from '../domain/Person';
import { IBoatInfo, IPutBoat_Request, IBoat_Response } from '../domain/Boat';
import { IVehicleInfo, IPutVehicle_Request, IVehicle_Response } from '../domain/Vehicle';
import { IConfigurationFieldValue } from '../domain/ConfigurationField';
import { ISafetyCheckInfo } from '../domain/SafetyCheck';
import { IViolationTypeInfo } from '../domain/Violation';
import { IUserInfo } from '../domain/User';
import { IClient } from '../domain/Client';
import { formatDateForItem, formatDateTimeForSave, loadRegBoatList, loadRegPersonList } from '../services/utils';

import { personOutline, boatOutline, closeOutline, carOutline, calendarOutline,
         chevronForwardOutline, chevronBackOutline, arrowForward, camera, trashOutline} from 'ionicons/icons';
import '../pages/css/common.css';
import './HeaderActivity.css';
import MapItemSimple from './MapItemSimple.js';
//#endregion "Imports"

interface AddEditActivityItemProps extends RouteComponentProps {
    isOnline: boolean;
    isExternal: string;
}

//#region  Reference Tabels Area
const seasList = () => {
    let list: ISeasInfo[] = [];
    if (window.localStorage.getItem("seas")) {
        list = JSON.parse(String(window.localStorage.getItem("seas"))) as ISeasInfo[];
    }
    return list;
}

const windsList = () => {
    let list: IWindInfo[] = [];
    if (window.localStorage.getItem("winds")) {
        list = JSON.parse(String(window.localStorage.getItem("winds"))) as IWindInfo[];
    }
    return list;
}

const weatherList = () => {
    let list: IWeatherInfo[] = [];
    if (window.localStorage.getItem("weather")) {
        list = JSON.parse(String(window.localStorage.getItem("weather"))) as IWeatherInfo[];
    }
    return list;
}

const incidentDispositionList = () => {
    let list: IIncidentDispositionInfo[] = [];
    if (window.localStorage.getItem("incidentDispositions")) {
        list = JSON.parse(String(window.localStorage.getItem("incidentDispositions"))) as IIncidentDispositionInfo[];
    }
    return list;
}

const equipmentStatusList = () => {
    let list: IEquipmentStatusInfo[] = [];
    if (window.localStorage.getItem("equipmentStatuses")) {
        list = JSON.parse(String(window.localStorage.getItem("equipmentStatuses"))) as IEquipmentStatusInfo[];
    }
    return list;
}

const activityLogRoleList = () => {
    let list: IActivityLogRoleInfo[] = [];
    if (window.localStorage.getItem("activityLogRoles")) {
        list = JSON.parse(String(window.localStorage.getItem("activityLogRoles"))) as IActivityLogRoleInfo[];
    }
    return list;
}

const harborList = () => {
    let clients = JSON.parse(String(window.localStorage.getItem("clients")));
    if (clients && clients.length > 1) {
        let clientListSorted = clients.filter((c:any) => c.ClientID !== -1)
                                    .sort((a:any,b:any) => { 
                                        if (a.ClientName < b.ClientName) return -1;
                                        if (a.ClientName > b.ClientName) return 1;
                                        return 0;
                                    });
        let clientList = clientListSorted.map((client:any) => ({
                            id: client.ClientID.toString(),
                            name: client.ClientName
                        }));
        return clientList;
    }
}

const deliveryMethodsList = () => {
    let list: IDeliveryMethodInfo[] = [];
    if (window.localStorage.getItem("deliveryMethods")) {
        list = JSON.parse(String(window.localStorage.getItem("deliveryMethods"))) as IDeliveryMethodInfo[];
    }
    return list;
}
//#endregion

const AddEditActivityItem : React.FC<AddEditActivityItemProps> = ({match, history, location, isOnline, isExternal}) => {
    const defaultHarborID =  window.localStorage.getItem("defaultClient");
    const _username = window.localStorage.getItem("username");

//#region "State"
    const type =  (match.params as RouteParams).type;
    const _clientId = (match.params as RouteParams).clientId;
    const activityId = (match.params as RouteParams).id;
    const _permitId = (match.params as RouteParams).permitId || 0;
    const _mooringId = (match.params as RouteParams).mooringId || 0;
    //const _personId = (match.params as RouteParams).personId || 0;
    //const _boatId = (match.params as RouteParams).boatId || 0;

    const myContext = useContext<AppContextInterface|null>(AppContext);
    const _token  = String(window.localStorage.getItem("token"));
    let _format24 = "0";
    if (window.localStorage.getItem("format24"))
        _format24 = String(window.localStorage.getItem("format24"));

    const [stateActivityId, setStateActivityId] = useState<string>(activityId);
    const [activityLog, setActivityLog] = useState({} as IActivityLogResult);
    const [clientId, setClientId] = useState<string>(_clientId);
    const [activityType, setActivityType] = useState(type);
    const [harborIsVisible] = useState<boolean>(!(defaultHarborID && String(defaultHarborID) !== "-1"));
    const [endIsVisible] = useState<boolean>(type === '1' || type === '2' || type === '3' || type === '4');
    
    const [startDate, setStartDate] = useState(Date());
    const [endDate, setEndDate] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [comments, setComments] = useState('');
    const [pinned, setPinned] = useState<boolean>(false);
    const [category, setCategory] = useState('');
    const [locationA, setLocationA] = useState('');
    const [weatherSource, setWeatherSource] = useState('');
    const [weatherId, setWeatherId] = useState<number|null>(null);
    const [windId, setWindId] = useState<number|null>(null);
    const [seasId, setSeasId] = useState<number|null>(null);
    const [tide, setTide] = useState('');
    const [incidentDispositionId, setIncidentDispositionId] = useState<number|null>(null);
    const [isDisabled, setIsDisabled] = useState<boolean|undefined>(false);

    const [boatIds, setBoatIds] = useState<ILocalIdentifier[]>([]);
    const [singleVesselId, setSingleVesselId] = useState<ILocalIdentifier[]>([]);
    const [searchVessel, setSearchVessel] = useState('');
    const [selectedBoatName, setSelectedBoatName] = useState('');
    const [vesselSelectionVisibility, setVesselSelectionVisibility] = useState<boolean>(false);
    const [vesselAddVisibility, setVesselAddVisibility] = useState<boolean>(false);
    const [vesselRegDoc, setVesselRegDoc] = useState('');
    const [vesselBoatName, setVesselBoatName] = useState('');
    const [vesselLength, setVesselLength] =  useState<number>(0);
    const [addedVesselLength, setAddedVesselLength] =  useState<number|null>(0);
    const [storageBoats, setStorageBoats] = 
            useState(window.localStorage.getItem("boats") ? String(window.localStorage.getItem("boats")) : '');
   
    const [vehicleIds, setVehicleIds] = useState<number[]>([]);
    const [singleVehicleId, setSingleVehicleId] = useState<number[]>([]);
    const [searchVehicle, setSearchVehicle] = useState('');
    const [selectedVehicleName, setSelectedVehicleName] = useState('');
    const [vehicleSelectionVisibility, setVehicleSelectionVisibility] = useState<boolean>(false);
    const [vehicleAddVisibility, setVehicleAddVisibility] = useState<boolean>(false);
    const [vehicleLicensePlate, setVehicleLicensePlate] = useState('');
    //const [warningLengthVisibility, setWarningLengthVisibility] = useState(false);
    const [storageVehicles, setStorageVehicles] = 
            useState(window.localStorage.getItem("vehicles") ? String(window.localStorage.getItem("vehicles")) : '');

    const [personIds, setPersonIds] = useState<ILocalIdentifierPerson[]>([]);
    const [singlePersonId, setSinglePersonId] = useState<ILocalIdentifierPerson[]>([]);
    const [searchPerson, setSearchPerson] = useState('');
    const [selectedPersonName, setSelectedPersonName] = useState('');
    const [personSelectionVisibility, setPersonSelectionVisibility] = useState<boolean>(false);
    const [personAddVisibility, setPersonAddVisibility] = useState<boolean>(false);
    const [personFirstName, setPersonFirstName] = useState('');
    const [personLastName, setPersonLastName] = useState('');
    const [personBirthDate, setPersonBirthDate] = useState('');
    const [personEmail, setPersonEmail] =  useState('');
    const [personPrimaryPhone, setPersonPrimaryPhone] =  useState('');
    const [personMailingStreet, setPersonMailingStreet] = useState('');
    const [personMailingState, setPersonMailingState] = useState('');
    const [personMailingCity, setPersonMailingCity] = useState('');
    const [personMailingZipCode, setPersonMailingZipCode] = useState('');
    const [storagePersons, setStoragePersons] = 
            useState(window.localStorage.getItem("persons") ? String(window.localStorage.getItem("persons")) : '');

    const [userIds, setUserIds] = useState<string[]>(activityId === "0" ? 
                    ((defaultHarborID && defaultHarborID !== "-1") ? 
                        [String(window.localStorage.getItem("username"))] 
                        : []) 
                    : []);
    const [singleUserId, setSingleUserId] = useState<string[]>(activityId === "0" ? 
                    ((defaultHarborID && defaultHarborID !== "-1") ? 
                        [String(window.localStorage.getItem("username"))] 
                        : []) 
                    : []);
    const [searchUser, setSearchUser] = useState('');
    const [selectedUserName, setSelectedUserName] = useState('');
    const [userSelectionVisibility, setUserSelectionVisibility] = useState<boolean>(false);

    const [approved, setApproved] = useState<boolean>(false);
    const [approvedBy, setApprovedBy] = useState('');
    const [equipmentId, setEquipmentId] = useState<number|null>(null);
    const [quantity, setQuantity] = useState<number|null>(null);
    const [ticket, setTicket] = useState('');
    const [equipmentStatusId, setEquipmentStatusId] = useState<number|null>(null);
    const [equipmentTypeId, setEquipmentTypeId] = useState<number|null>(null);

    const [activityTypeId, setActivityTypeId] = useState('');
    const [messagePopup, setMessagePopup] = useState('');
    const [messageLoading, setMessageLoading] = useState('');

    const [offenses, setOffenses] = useState<IViolationInfo[]>([]);
    const [searchOffense, setSearchOffense] = useState('');
    const [selectedOffenseName, setSelectedOffenseName] = useState('');
    const [offenseSelectionVisibility, setOffenseSelectionVisibility] = useState<boolean>(false);
    const [fee, setFee] = useState("");
    const [fine, setFine] = useState<number>(0);
    const [offenseAddVisibility, setOffenseAddVisibility] = useState<boolean>(false);
    const [offenseDescription, setOffenseDescription] =  useState('');
    const [offenseFine, setOffenseFine] = useState<number>(0);
    const [storageViolationTypes] = 
            useState(window.localStorage.getItem("violationTypes") ? String(window.localStorage.getItem("violationTypes")) : '');

    const [warning, setWarning] =  useState<boolean>(false);
    const [isPrivate, setIsPrivate] =  useState<boolean>(false);

    const [isPreInspection, setIsPreInspection] = useState(false);
    const [preInspectionText, setPreInspectionText] = useState('');
    const [postInspectionText, setPostInspectionText] = useState('');
    const [activityTypeListVisible, setActivityTypeListVisible] = useState(true);
    const [categoryListVisible, setCategoryListVisible] = useState(true);
    const [locationListVisible, setLocationListVisible] = useState(true);

    const [preInspectionVisibility, setPreInspectionVisibility] = useState(false);
    const [postInspectionVisibility, setPostInspectionVisibility] = useState(false);
    const [equipmentInspectionPoints, setEquipmentInspectionPoints] = useState<IEquipmentInspectionPointInfo[]>([]);

    const [gar, setGar] = useState<IGARInfo|null>(null);
    const [garSelectionVisibility, setGarSelectionVisibility] = useState(false);
    const [selectedGARName, setSelectedGARName] = useState('');

    const [supervision, setSupervision] = useState(10);
    const [planning, setPlanning] = useState(10);
    const [crewSelection, setCrewSelection] = useState(10);
    const [crewEndurance, setCrewEndurance] = useState(10);
    const [garWeather, setGarWeather] = useState(10);
    const [caseComplexity, setCaseComplexity] = useState(10);
    const [garTotal, setGarTotal] = useState(60);
    const [, setGarColor] = useState("");
    const [garColorLabel, setGarColorLabel] = useState("");

    const [deliveryMethodId, setDeliveryMethodId] = useState<number|null>(null);

    const [safetyChecks, setSafetyChecks] = useState<ISafetyCheckItem[]>([]);

    const [mapVisibility, setMapVisibility] = useState(false);
    const [activityLogLatitude, setActivityLogLatitude] = useState<number|null>(null);
    const [activityLogLongitude, setActivityLogLongitude] = useState<number|null>(null);
    const [tempLatitude, setTempLatitude] = useState<number|null>(null);
    const [tempLongitude, setTempLongitude] = useState<number|null>(null);

    const [imagesVisibility, setImagesVisibility] = useState(false);
    const [selectedImagesSummary, setSelectedImagesSummary] = useState('');
    const [images, setImages] = useState<Photo[]>([]);
    const [initialImages, setInitialImages] = useState<Photo[]>([]);
    const [fullImageVisibility, setFullImageVisibility] = useState(false);
    const [fullPhoto, setFullPhoto] = useState<Photo|null>(null);

    const [showLoading, setShowLoading] = useState(false);
    const [showLoadingSave, setShowLoadingSave] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [displayFormat] = useState((_format24 === "0") ? "MMM DD YYYY hh:mm a" : "MMM DD YYYY HH:mm");
    const [pickerFormat] = useState((_format24 === "0") ? "MMM DD YYYY hh mm a" : "MMM DD YYYY HH mm");
    const [pickerFormatDataOnly] = useState("MMM DD YYYY");

    const [regBoatList, setRegBoatList] = useState<IBoatInfo[]>([]);
    const [regPersonList, setRegPersonList] = useState<IPersonInfo[]>([]);

    const {photos, takePhoto, deletePhoto} = usePhotoGallery();

//#endregion "State"

//#region "Loading"
    useEffect(()=> {
        if (defaultHarborID && defaultHarborID !== "-1")
            setClientId(defaultHarborID);
        if (activityType === "3" || activityType === "5" || activityType === "6" || activityType === "8")
            loadRegBoats(_token);
        if (activityType === "3" || activityType === "6")
            loadRegPersons(_token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[activityType]);

    useEffect(() => {
        if (activityId !== '0') {
            loadActivity(activityId);
        }
        else {
            FixSelectedUserName(userIds);
            if (defaultHarborID && defaultHarborID !== "-1") {
                if (activityType === '3' || activityType === '7')
                    loadCondition(defaultHarborID); 

                if (isExternal === "1") {

                }
            }       
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activityId]);

    useEffect(() => {
        setImages([...initialImages,...photos]); 
    }, [photos, initialImages ]);

    const loadRegBoats = async(_token:string) => {
        //setMessageLoading('Getting data...');
        //setShowLoading(true);
        let regBoatList:IBoatInfo[] = await loadRegBoatList(_token);
        if (regBoatList) {
            setRegBoatList(regBoatList);
        }
        //setShowLoading(false);
    }

    const loadRegPersons = async(_token:string) => {
        //setMessageLoading('Getting data...');
        //setShowLoading(true);
        let regPersonList:IPersonInfo[] = await loadRegPersonList(_token);
        if (regPersonList) {
            setRegPersonList(regPersonList);
        }
        //setShowLoading(false);
    }

    const loadActivity = async(id:string) => {
        setMessageLoading('Getting data...');
        setShowLoading(true);
        let _token = window.localStorage.getItem("token");
        if (_token) {
            //await loadEquipmentList(_clientId);
            new DataAccessService().getActivityLogById(_token, id)
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let activityLogItem = JSON.parse(expectedData.toString()) as IActivityLogResult_Response;
                        if (activityLogItem) {
                            fillInState(activityLogItem.Result);
                            setShowLoading(false);
                        }
                        else {
                            setShowLoading(false);
                        }
                    }
                    else {
                        setShowLoading(false);
                    }
                },
                function (response) {
                    setShowLoading(false);
            });
        }
        else
           setShowLoading(false);
    }

    const fillInState = (activityLogItem:IActivityLogResult) => {
        console.log({activityLogItem});
        setActivityLog(activityLogItem);
        setActivityTypeId(activityLogItem.ActivityLogEntryTypeID.toString());
        if (activityLogItem.ClientID.toString() !== _clientId)
            setClientId(activityLogItem.ClientID.toString());
        setStartDate(formatDateForItem(activityLogItem.DateStarting));
        if (activityLogItem.DateEnding){
            setEndDate(formatDateForItem(activityLogItem.DateEnding));
        }
        if (activityLogItem.DeliveryDate){
            setDeliveryDate(formatDateForItem(activityLogItem.DeliveryDate));
        }
        setActivityType(activityLogItem.ActivityType);
        setComments(activityLogItem.Comments);
        if (activityLogItem.Pinned === undefined)
            setPinned(false);
        else
            setPinned(Boolean(activityLogItem.Pinned));
        setCategory(activityLogItem.Category);
        setLocationA(activityLogItem.Location);
        setWeatherSource (activityLogItem.ConditionsSource);

        setWeatherId(activityLogItem.WeatherID || 0);
        setWindId(activityLogItem.WindID || 0);
        setSeasId(activityLogItem.SeasID || 0);
        setTide(activityLogItem.Tide);
        setIncidentDispositionId(activityLogItem.IncidentDispositionID);
        setWeatherSource(activityLogItem.ConditionsSource);

        setEquipmentId(activityLogItem.EquipmentID);
        let item: IEquipmentInfo|undefined = equipmentList.find((x) => x.EquipmentID === activityLogItem.EquipmentID);
        if (item) {
            let itemType: IEquipmentTypeInfo|undefined = equipmentTypes.find((x) => x.EquipmentTypeID === (item as IEquipmentInfo).EquipmentTypeID);
            if (itemType)
                setEquipmentTypeId(itemType.EquipmentTypeID);
            if (item.EquipmentStatusID)
                setEquipmentStatusId(item.EquipmentStatusID);
        }

        if (activityLogItem.Approved === undefined)
            setApproved(false);
        else
            setApproved(Boolean(activityLogItem.Approved));

        setApprovedBy(activityLogItem.ApprovedBy);

        if (activityLogItem.Persons){
            FixSelectedPersonName(activityLogItem.Persons.map(x => x.ID));
            setPersonIds(activityLogItem.Persons);
        }
        else
            FixSelectedPersonName(personIds.map(x => x.ID));

        if (activityLogItem.Users){
            FixSelectedUserName(activityLogItem.Users);
            setUserIds(activityLogItem.Users);
        }
        else
            FixSelectedUserName(userIds);

        if (activityLogItem.Vessels){
            FixSelectedVesselName(activityLogItem.Vessels.map(x => x.ID));
            setBoatIds(activityLogItem.Vessels);
            if (activityLogItem.ActivityLogEntryTypeID === 8 && activityLogItem.Vessels.length === 1)
                setAddedVesselLength(activityLogItem.VesselLength);
        }
        else
            FixSelectedVesselName(boatIds.map(x => x.ID));

        if (activityLogItem.Vehicles){
            FixSelectedVehicleName(activityLogItem.Vehicles);
            setVehicleIds(activityLogItem.Vehicles);
        }
        else
            FixSelectedVehicleName(vehicleIds);

        if (activityLogItem.InspectionPoints) {
            setEquipmentInspectionPoints(activityLogItem.InspectionPoints);
            setPrePostInspectionTextInit(activityLogItem.InspectionPoints);
        }

        if (activityLogItem.GAR) {
            let itemGar = new GARInfo(activityLogItem.GAR.ActivityLogGARID,
                activityLogItem.GAR.Supervision,
                activityLogItem.GAR.Planning,
                activityLogItem.GAR.CrewSelection,
                activityLogItem.GAR.Endurance,
                activityLogItem.GAR.Weather,
                activityLogItem.GAR.CaseComplexity,
                activityLogItem.GAR.Total)

            setGar(itemGar);
            setSupervision(activityLogItem.GAR.Supervision);
            setPlanning(activityLogItem.GAR.Planning);
            setCrewSelection(activityLogItem.GAR.CrewSelection);
            setCrewEndurance(activityLogItem.GAR.Endurance);
            setGarWeather(activityLogItem.GAR.Weather);
            setCaseComplexity(activityLogItem.GAR.CaseComplexity);
            setGarTotal(activityLogItem.GAR.Total);
            setSelectedGARName("Total GAR Score " + (activityLogItem.GAR.Total || 0).toString());

            if (activityLogItem.GAR.Total < 24) {
                setGarColor("my-toolbar-green");
                setGarColorLabel("my-ion-item-green");
            }
            else if (activityLogItem.GAR.Total < 45) {
                setGarColor("my-toolbar-yellow");
                setGarColorLabel("my-ion-item-yellow");
            }
            else {
                setGarColor("my-toolbar-red");
                setGarColorLabel("my-ion-item-red");
            }
        }
        else {
            setSelectedGARName("Fill in GAR Score");
            setGarColorLabel("my-ion-item");
            if (garTotal < 24) {
                setGarColor("my-toolbar-green");
            }
            else if (garTotal < 45) {
                setGarColor("my-toolbar-yellow");
            }
            else {
                setGarColor("my-toolbar-red");
            }
        }

        setQuantity(activityLogItem.Quantity);
        setWarning(activityLogItem.Warning ? activityLogItem.Warning : false );
        setIsPrivate(activityLogItem.IsPrivate ? activityLogItem.IsPrivate : false );
        setTicket(activityLogItem.TicketNumber ? activityLogItem.TicketNumber : '');
        setDeliveryMethodId(activityLogItem.DeliveryMethodID);
        if (activityLogItem.Violations) {
            FixSelectedOffenseName(activityLogItem.Violations);
            setOffenses(activityLogItem.Violations);
            console.log({"list":searchOffenseList});
        }
        else {
            FixSelectedOffenseName(offenses);
        }

        if (activityLogItem.Fine) {
            setFine(activityLogItem.Fine); 
            setFee('$' + activityLogItem.Fine.toString()); 
        }
        else
            calculateFee(activityLogItem.Warning ? activityLogItem.Warning : false, activityLogItem.Violations);


        if (activityLogItem.SafetyChecks) {
            setSafetyChecks(activityLogItem.SafetyChecks);
        }

        if (activityLogItem.Latitude) {
            setActivityLogLatitude(activityLogItem.Latitude);
        }

        if (activityLogItem.Longitude) {
            setActivityLogLongitude(activityLogItem.Longitude);
        }

        if (activityLogItem.Photos) {
            let _myPhotos= activityLogItem.Photos.map((x) => {
                let item =  {
                    photoId: x.PhotoID,
                    filepath:  x.FileName,
                    webviewPath: x.FileUrl
                };
                return item as Photo
            });
            setImages(_myPhotos);
            setInitialImages(_myPhotos);
            let selectedText = getImagesText(_myPhotos);
            setSelectedImagesSummary(selectedText);
        }

    }
//#endregion "Loading"

//#region "Initialisation"
    const labelStart = () => {
        switch (type) {
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                return 'Date/Time';
            case '1':
            case '2':
            case '3':
                return "Start";
            case '4':
                return 'Started Use On';
            default:
                break;
        }
    };

    // const endIsVisible = (activityType === '1' || activityType === '2' || activityType === '3' || activityType === '4') ? true : false;

    const labelEnd = () => {
        switch (type) {
            case '1':
            case '2':
            case '3':
                return "End";
            case '4':
                return 'Ended Use On';
            default:
                break;
        }
    };

    const labelStaffPerson = (type === '3') ? 'Staff Person' : 'Staff Person(s)';
//#endregion "Initialisation"

//#region "DataSets - Configuration Field Values"
    const activityTypeList = useMemo(() => {
        let list: IConfigurationFieldValue[] = [];
        let listToReturn: IConfigurationFieldValue[] = [];
        if (window.localStorage.getItem("activityTypes")) {
            list = JSON.parse(String(window.localStorage.getItem("activityTypes"))) as IConfigurationFieldValue[];
            if (clientId !== '0')
                listToReturn = list.filter((x) => x.ClientID.toString() === clientId);
            else
                listToReturn = list;
        }
        if (listToReturn.length === 0)
            setActivityTypeListVisible(false);
        else
            setActivityTypeListVisible(true);
        return listToReturn;
    }, [clientId]);

    const categoryList = useMemo(() => {
        let list: IConfigurationFieldValue[] = [];
        let listToReturn: IConfigurationFieldValue[] = [];
        if (window.localStorage.getItem("categories")) {
            list = JSON.parse(String(window.localStorage.getItem("categories"))) as IConfigurationFieldValue[];
        }
        if (clientId !== '0')
            listToReturn = list.filter((x) => x.ClientID.toString() === clientId);
        else
            listToReturn = list;
        if (listToReturn.length === 0)
            setCategoryListVisible(false);
        else
            setCategoryListVisible(true);
        return listToReturn;
    },[clientId]);

    const locationList = useMemo(() => {
        let list: IConfigurationFieldValue[] = [];
        let listToReturn: IConfigurationFieldValue[] = [];
        if (window.localStorage.getItem("locations")) {
            list = JSON.parse(String(window.localStorage.getItem("locations"))) as IConfigurationFieldValue[];
        }
        if (clientId !== '0')
            listToReturn = list.filter((x) => x.ClientID.toString() === clientId);
        else
            listToReturn = list;
        if (listToReturn.length === 0)
            setLocationListVisible(false);
        else
            setLocationListVisible(true);
        return listToReturn;
    }, [clientId]);
//#endregion "DataSets - Configuration Field Values"

//#region "DataSets - Related to Activity Log Entries"
    const personList = useMemo(() => {
        let list: IPersonInfo[] = [];
        let listToReturn: IPersonInfo[] = [];
       
        if (storagePersons !== '') {
            list = JSON.parse(storagePersons) as IPersonInfo[];
        }
        listToReturn = list.filter((x) => x.FirstName || x.LastName);
        if (clientId !== '0') {
            listToReturn = list.filter((x) => (x.ClientID.toString() === clientId || x.ClientID.toString() === "0" || x.IsReg)
                                                && (x.FirstName || x.LastName))
        }
        return listToReturn;
    }, [clientId, storagePersons]);

    const boatList = useMemo(() => {
        let list: IBoatInfo[] = [];
        let listToReturn: IBoatInfo[] = [];

        if (storageBoats !== '') {
            list = JSON.parse(storageBoats) as IBoatInfo[];
        }
        listToReturn = list.filter((x) => x.BoatRegistrationOrDockNumber || x.BoatName);
        if (clientId !== '0') {
            listToReturn = list.filter((x) => (x.ClientID.toString() === clientId || x.IsReg)
                                                && (x.BoatRegistrationOrDockNumber || x.BoatName))
        }
        return listToReturn;
    }, [clientId, storageBoats]);

    const vehicleList = useMemo(() => {
        let list: IVehicleInfo[] = [];
        if (storageVehicles !=='') {
            list = JSON.parse(String(storageVehicles)) as IVehicleInfo[];
        }
        if (clientId !== '0') {
            return list.filter((x) => x.ClientID.toString() === clientId)
        }
        return list;
    },[clientId, storageVehicles]);

    const violationTypeList = useMemo(() => {
        let list: IViolationTypeInfo[] = [];
        let listToReturn: IViolationTypeInfo[] = [];
        if (storageViolationTypes !== ''){
            list = JSON.parse(String(storageViolationTypes)) as IViolationTypeInfo[];
            listToReturn = list;
        }
        if (clientId !== '0') {
            listToReturn = list.filter((x) => x.ClientID.toString() === clientId)
        }
        
        return listToReturn.sort((a,b) => { if ((a.Ordinal || 0) < (b.Ordinal || 0)) return -1;
                                            if ((a.Ordinal || 0) > (b.Ordinal || 0)) return 1;
                                            return 0; });
    },[clientId, storageViolationTypes]);

    const userList = useMemo(() => {
        let list: IUserInfo[] = [];
        let listToReturn: IUserInfo[] = [];
        if (window.localStorage.getItem("users")) {
            list = JSON.parse(String(window.localStorage.getItem("users"))) as IUserInfo[]; 
            listToReturn = list.filter((x) => (x.ClientID.toString() === clientId) && x.DisplayName);
        }
        return listToReturn;
    },[clientId]);

//#endregion "DataSets - Related to Activity Log Entries"

//#region "DataSets - Configuration Tabels For Client"
    const equipmentTypes = useMemo(() => {
        let list: IEquipmentTypeInfo[] = [];
        let listToReturn: IEquipmentTypeInfo[] = [];
        if (window.localStorage.getItem("equipmentTypes")) {
            list = JSON.parse(String(window.localStorage.getItem("equipmentTypes"))) as IEquipmentTypeInfo[];
            if (clientId !== '0') {
                listToReturn = list.filter((x) => x.ClientID.toString() === clientId);
            } 
        }
        return listToReturn;
    },[clientId]);

    const equipmentList = useMemo(() => {
        let list: IEquipmentInfo[] = [];
        let listToReturn: IEquipmentInfo[] = [];
        if (window.localStorage.getItem("equipments")) {
            list = JSON.parse(String(window.localStorage.getItem("equipments"))) as IEquipmentInfo[];
            if (clientId !== '0') {
                listToReturn = list.filter((x) => x.ClientID.toString() === clientId);
            } 
        }
        return listToReturn;
    },[clientId]);

    const equipmentInspectionPointList = useMemo(() => {
        let list: IEquipmentInspectionPointItem[] = [];
        let listToReturn: IEquipmentInspectionPointItem[] = [];
        if (window.localStorage.getItem("equipmentInspectionPoints")) {
            list = JSON.parse(String(window.localStorage.getItem("equipmentInspectionPoints"))) as IEquipmentInspectionPointItem[];
            if (equipmentId && equipmentTypeId) {
                listToReturn = list.filter((x) => x.EquipmentTypeID === equipmentTypeId);
            }
        }
        return listToReturn;
    },[equipmentTypeId, equipmentId])

    const safetyCheckList = useMemo(() => {
        let list: ISafetyCheckInfo[] = [];
        if (window.localStorage.getItem("safetyChecks")) {
            list = JSON.parse(String(window.localStorage.getItem("safetyChecks"))) as ISafetyCheckInfo[];
        }
        if (clientId !== '0') {
            return list.filter((x) => x.ClientID.toString() === clientId);
        }
        return list;
    },[clientId]);

    const loadCondition = async(_clientId:string) => {
        setMessageLoading('Getting data...');
        setShowLoading(true);
        let response = await getCondition(_token, _clientId);
        if ((response as any).data) {
            let objCondition:IConditionInfo = (JSON.parse((response as any).data) as ICondition_Response).Info;
            if (objCondition) {
                console.log({objCondition});
                setWeatherSource(objCondition.Source);
                setWindId(objCondition.WindsID);
                setWeatherId(objCondition.WeatherID);
                setSeasId(objCondition.SeasID);
                setTide(objCondition.Tide);
            }
        }
        setShowLoading(false);
    }

//#endregion "DataSets - Configuration Tabels For Client"

//#region "Different Components Logic"
    const startDateChange = useCallback((ev :any) => {
        let _val = ev.detail.value;
        let _formattedValue = '';
        let indexGMT = _val.indexOf('GMT');
        if (indexGMT > -1) {
            _formattedValue = _val.substring(0, indexGMT);
            if (_formattedValue.indexOf("Invalid") === -1) 
                setStartDate(_formattedValue);
        } else {
            let indexT = _val.indexOf('T');
            if (indexT > -1) {
                _formattedValue = _val.substring(0, indexT+6);
                if (_formattedValue.indexOf("Invalid") === -1) 
                    setStartDate(_formattedValue);
            }
        }

    },[]);

    const endDateChange = useCallback((ev :any) => {
        let _val = ev.detail.value;
        let _formattedValue = '';
        let indexGMT = _val.indexOf('GMT');
        if (indexGMT > -1) {
            _formattedValue = _val.substring(0, indexGMT);
            if (_formattedValue.indexOf("Invalid") === -1)
                setEndDate(_formattedValue);
        }
        else {
            let indexT = _val.indexOf('T');
            if (indexT > -1) {
                _formattedValue = _val.substring(0, indexT+6);
                if (_formattedValue.indexOf("Invalid") === -1) 
                    setEndDate(_formattedValue);
            }
        }
    },[]);

    const deliveryDateChange = useCallback((ev :any) => {
        let _val = ev.detail.value;
        let _formattedValue = '';
        let indexGMT = _val.indexOf('GMT');
        if (indexGMT > -1) {
            _formattedValue = _val.substring(0, indexGMT);
            if (_formattedValue.indexOf("Invalid") === -1)
                setDeliveryDate(_formattedValue);
        }
        else {
            let indexT = _val.indexOf('T');
            if (indexT > -1) {
                _formattedValue = _val.substring(0, indexT+6);
                if (_formattedValue.indexOf("Invalid") === -1) 
                    setDeliveryDate(_formattedValue);
            }
        }
    },[]);

    const birthDateChange = useCallback((ev :any) => {
        let _val = ev.detail.value;
        let _formattedValue = '';
        let indexGMT = _val.indexOf('GMT');
        if (indexGMT > -1) {
            _formattedValue = _val.substring(0, indexGMT);
            if (_formattedValue.indexOf("Invalid") === -1)
                setPersonBirthDate(_formattedValue);
        }
        else {
            let indexT = _val.indexOf('T');
            if (indexT > -1) {
                _formattedValue = _val.substring(0, indexT+6);
                if (_formattedValue.indexOf("Invalid") === -1) 
                    setPersonBirthDate(_formattedValue);
            }
        }
    },[]);

    const changeEquipment = (e:any) => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
            return;
        }
        else {
            let _equipment: IEquipmentInfo|undefined = equipmentList.find((x) => x.EquipmentID === e.detail.value);
            if (_equipment) {
                setEquipmentStatusId(_equipment.EquipmentStatusID);
                setEquipmentId(e.detail.value);
                let item:IEquipmentTypeInfo|undefined = equipmentTypes.find((x) => x.EquipmentTypeID === (_equipment as IEquipmentInfo).EquipmentTypeID);
                if (item)
                    setEquipmentTypeId(_equipment.EquipmentTypeID);
                if (_equipment.EquipmentStatusID)
                    setEquipmentStatusId(_equipment.EquipmentStatusID);
            }
        }
    }

    const changeApproved = (e:any) => {
        setApproved(e.detail.checked);
        if (e.detail.checked) {
            setApprovedBy(String(_username));
        }
    }

    const changeWarning = (e:any) => {
        setWarning(e.detail.checked);
        calculateFee(e.detail.checked, offenses);
    }  

    const changeClient = (_value:string) => { 
        setClientId(_value);
         if (activityType === '3' || activityType === '7')
            loadCondition(_value);
    }

    const changeWeatherSource = (_value:string) => {
        setWeatherSource(_value);
        if (_value.indexOf('NWS') > -1)
            setIsDisabled(true);
        else
            setIsDisabled(false);
    }

    const changeActivityLogRoleID = (_value: number, _item: ILocalIdentifierPerson) => {
        //let listPersonIds = personIds;
        //let _newItem = {..._item, ActivityLogRoleID: _value};
        let newListPersonIds = personIds.map((x) => {
            if (x.ID === _item.ID) 
                return {...x, ActivityLogRoleID: _value} 
            else
                return x;
        });
        setPersonIds(newListPersonIds);
    }
//#endregion "Different Components Logic"

//#region "Vessel logic"
    const pickBoat = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setVesselSelectionVisibility(true);
    };

    const searchVesselList  = useMemo(() => {
        let entireBoatList = [];
        entireBoatList = [...boatList, ...regBoatList];

        if (boatIds.length === 0) {
            return entireBoatList
                .filter((x) => { return (x.BoatRegistrationOrDockNumber + (x.ClientID.toString() !== clientId ? " (Reg)" :"") + (x.BoatName ? ', ' + x.BoatName : "")).toLowerCase()
                                        .indexOf(searchVessel.toLowerCase()) > -1; })
                .map((x) => {
                    return { FullName: x.BoatRegistrationOrDockNumber + (x.ClientID.toString() !== clientId ? " (Reg)" :"") + (x.BoatName ? ', ' + x.BoatName : ""), 
                             Id: x.BoatID,
                             IsReg: x.IsReg,
                             Length: x.LengthInFeet };})
                .slice(0, 5);
        }
        else {
            let listToReturn = entireBoatList
                .filter((x) => { return boatIds.map(x => x.ID).includes(x.BoatID) })
                .map((x) => {
                    return { FullName: x.BoatRegistrationOrDockNumber + (x.ClientID.toString() !== clientId ? " (Reg)" :"") + (x.BoatName ? ', ' + x.BoatName : ""), 
                             Id: x.BoatID,
                             IsReg: x.IsReg,
                             Length: x.LengthInFeet };});

            let numberToBeReturned:number = 5 - boatIds.length;
            let remainedList = entireBoatList
                .filter((x) => { return !boatIds.map(x => x.ID).includes(x.BoatID)
                                    && (x.BoatRegistrationOrDockNumber + (x.ClientID.toString() !== clientId ? " (Reg)" :"") + (x.BoatName ? ', ' + x.BoatName : "")).toLowerCase()
                                        .indexOf(searchVessel.toLowerCase()) > -1 }) 
                .map((x) => {
                    return { FullName: x.BoatRegistrationOrDockNumber + (x.ClientID.toString() !== clientId ? " (Reg)" :"") + (x.BoatName ? ', ' + x.BoatName : ""), 
                             Id: x.BoatID,
                             IsReg: x.IsReg, 
                             Length : x.LengthInFeet };})
                .slice(0, numberToBeReturned);

            remainedList.forEach(element => {
                listToReturn.push(element);
            });

            return listToReturn;
        }
    },[searchVessel, boatList, boatIds, clientId, regBoatList]);

    const closeSearchVessel = () => {
        FixSelectedVesselName(boatIds.map(x => x.ID));
        setSearchVessel('');
        safetyCheckListFiltered();
        if ((activityType === "3" || activityType === "6")  && boatIds.length === 1){
            loadPersonForBoat(boatIds[0].ID, boatIds[0].IsLocal);
        }
        setVesselSelectionVisibility(false);
    }

    const FixSelectedVesselName = (_boatIds : number[]) => {
        let entireBoatList = [...boatList, ...regBoatList];
        let _selectedBoatName = '';
        if (_boatIds.length === 0)
            _selectedBoatName = 'Select vessel';
        else if (_boatIds.length === 1) {
            let _boat = entireBoatList.find((x) => x.BoatID === _boatIds[0]);
            _selectedBoatName = _boat?.BoatRegistrationOrDockNumber + ( _boat?.BoatName ? ', ' + _boat?.BoatName : "");
        }
        else
            _selectedBoatName = _boatIds.length.toString() + ' vessels selected';

        setSelectedBoatName(_selectedBoatName);
    }

    const vesselSelect = (e:any, isReg:boolean|null) => {
        if (isNaN(e.detail.value)) return;

        let _value = Number(e.detail.value);
        let newList:ILocalIdentifier[] = boatIds;
        if (e.detail.checked) {
            let foundId = boatIds.find((x)=> x.ID ===_value);
            if (!foundId) {
                let newList:ILocalIdentifier[] = boatIds;
                let isLocal;
                if (isReg && isReg === true)
                    isLocal = false;
                else
                    isLocal = true;
                newList.push({ID:_value, IsLocal : isLocal});
                setBoatIds(newList);
            }
        }
        else {
            let index = newList.map(x => x.ID).indexOf(_value);
            if (index > -1) {
                newList.splice(index, 1);
                setBoatIds(newList);
            }
        }
    }

    const singleVesselIdSelect = (e:any) => {
        if (isNaN(e.detail.value)) return;

        let _value =Number(e.detail.value);
        let _isLocal = true;
        let _length = null;

        let _found = searchVesselList.find((x) => x.Id === _value);
        if (_found) {
            _length = _found.Length;
            if (_found.IsReg && _found.IsReg === true)
                _isLocal = false;
        }

        let item:ILocalIdentifier = {ID:_value, IsLocal : _isLocal};
        setSingleVesselId([item]);
        setBoatIds([item]);
        FixSelectedVesselName([_value]);
        setSearchVessel('');
        safetyCheckListFiltered();

        if ((activityType === "3" || activityType === "6")){
            loadPersonForBoat(_value, _isLocal);
        }
        if (activityType === "8" && _length) {
            setAddedVesselLength(Number(_length));
        }

        setVesselSelectionVisibility(false);   
    }

    const showVesselAdd = () => {
        setVesselAddVisibility(true);
    }

    const addVessel = () => {
        // if (vesselLength <= 0){
        //     setWarningLengthVisibility(true);
        //     return;
        // }
        setShowLoadingSave(true);
        let vesselToSave:IPutBoat_Request = {
            BoatID: 0,
            ClientID: Number(clientId),
            BoatRegistrationOrDockNumber: vesselRegDoc,
            BoatName: vesselBoatName,
            LengthInFeet: vesselLength
        };

        let vesselToSearch = vesselRegDoc + ', ' + vesselBoatName;
        if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) {
            setShowLoadingSave(true);
            let storedToken = window.localStorage.getItem("token");
            let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
            if (expireTokenDate > new Date()) {
                new DataAccessService()
                    .putBoat(String(storedToken), JSON.stringify(vesselToSave))
                        .then(
                            function(expectedData:any) {
                                if (expectedData) {
                                    let vesselListDB = (JSON.parse(expectedData.toString()) as IBoat_Response).Boats;
                                    if (vesselListDB.length === 1) {
                                        let objVesselList = JSON.parse(String(window.localStorage.getItem("boats")));
                                        if (!objVesselList)
                                            objVesselList = [];
                                        objVesselList.push(vesselListDB[0]);
                                        window.localStorage.setItem("boats", JSON.stringify(objVesselList));
                                        setStorageBoats(String(window.localStorage.getItem("boats")));    
                                    }
                                }
                                setShowLoadingSave(false);
                                clearAddVesselForm();
                                setSearchVessel(vesselToSearch);
                                setVesselAddVisibility(false);
                            },
                            function (response) {
                                setShowLoadingSave(false);
                                clearAddVesselForm();
                                setVesselAddVisibility(false);
                            }
                        );
            }
            else {
                setShowLoadingSave(false);
                clearAddVesselForm();
                setVesselAddVisibility(false);
            }
        }
    }

    const clearAddVesselForm = () => {
        setVesselRegDoc('');
        setVesselBoatName('');
        setVesselLength(0);
    }

    const closeAddVessel = () => {
        setVesselAddVisibility(false);
    }

    const changeVesselLength = (e:any) => {
        if (e.detail.value) {
            // if (Number(e.detail.value) > 0)
            //     setWarningLengthVisibility(false);
            setVesselLength(Number(e.detail.value));
        }
    }
 
    const loadPersonForBoat = async(_boatID:number, _isLocal:boolean) => {
        let _responsePersonStr = await getPersonForBoat(_token, _boatID.toString(), clientId);

        let _responsePerson = JSON.parse(_responsePersonStr) as IPersonInfo;
        if (_responsePerson) { 
            if (!_isLocal) {
                let listpersons = JSON.parse(storagePersons) as IPersonInfo[];
                _responsePerson.ClientID = 0;
                listpersons.push(_responsePerson);
                window.localStorage.setItem("persons", JSON.stringify(listpersons));
                setStoragePersons(String(window.localStorage.getItem("persons")));  
            }
            let _searchedPerson = personIds.find((x) => x.ID.toString () === _responsePerson.PersonID.toString());
            if (!_searchedPerson) {
                let newPerson: ILocalIdentifierPerson = {ActivityLogRoleID: null, 
                        ID: Number(_responsePerson.PersonID), 
                        IsLocal: _isLocal, 
                        Name: (_responsePerson.FirstName != null ? _responsePerson.FirstName : '') 
                            + ' ' 
                            + (_responsePerson.LastName != null ? _responsePerson.LastName : '' )}
                    personIds.push(newPerson);
                if (activityType === "3") {
                    setPersonIds(personIds);
                    FixSelectedPersonName(personIds.map(x => x.ID));
                }
                else {
                    setPersonIds([newPerson]); 
                    setSelectedPersonName(newPerson.Name);
                }
            }
        }
    }
//#endregion "Vessel Logic"

//#region "SafetyCheck"
    const getValueForsafetyCheck = useCallback((_safetyCheckId: number) => {
        if (safetyChecks.length === 0)
            return null;

        let itemFound = safetyChecks.find((sc) => sc.SafetyCheckID === _safetyCheckId);
        if (!itemFound)
            return null;

        return itemFound.Result !== null ? itemFound.Result.toString() : null;
    },[safetyChecks])

    const safetyCheckListFiltered = useCallback(() => {
        if (boatIds.length === 0  || clientId === '0')
            return [];

        let selectedBoat = boatList.find((x) => x.BoatID.toString() === boatIds[0].ID.toString());
        if (!selectedBoat)
            return [];

        let _boatType = '';
        if (selectedBoat.BoatType) {
            _boatType = selectedBoat.BoatType.toLowerCase();
        } 
       
        let _boatLength = 0;
        if (selectedBoat.LengthInFeet)
            _boatLength = selectedBoat.LengthInFeet;

        let filteredSafetyCheckList = safetyCheckList.filter((x:ISafetyCheckInfo) => !x.VesselType || (x.VesselType && x.VesselType.toLowerCase().indexOf(_boatType) >-1))
            .map((sc) => {
                return {
                    SafetyCheckID : sc.SafetyCheckID,
                    // eslint-disable-next-line no-useless-escape
                    Description: sc.Description,
                    Comments: sc.Comments,
                    value: ((sc.MinVesselLength && sc.MinVesselLength < _boatLength) || (sc.MaxVesselLength && sc.MaxVesselLength > _boatLength) )
                                    ? null : getValueForsafetyCheck(sc.SafetyCheckID),
                    disablePass: ((sc.MinVesselLength && sc.MinVesselLength < _boatLength) || (sc.MaxVesselLength && sc.MaxVesselLength > _boatLength) ) ? true : false,
                    disableFailed: ((sc.MinVesselLength && sc.MinVesselLength < _boatLength) || (sc.MaxVesselLength && sc.MaxVesselLength > _boatLength) ) ? true : false,
                    disableNA: false
                };
            });

        return filteredSafetyCheckList;
    },[boatIds, boatList, clientId, safetyCheckList, getValueForsafetyCheck])

    const selectSafetyCheckItemValue = (_value:string|undefined, _safetyCheckId: number) => {
        let newList:ISafetyCheckItem[] = safetyChecks;
        if (_value) {
            let found = safetyChecks.find((x)=> x.SafetyCheckID === _safetyCheckId);
            if (!found) {
                let _item = new SafetyCheckItem(_safetyCheckId, Number(_value));
                newList.push(_item);
                setSafetyChecks(newList);
            }
            else {
                var foundIndex = newList.findIndex(x => x.SafetyCheckID === _safetyCheckId);
                newList[foundIndex].Result = Number(_value);
                setSafetyChecks(newList);
            }
        }
    }
//#endregion "SafetyCheck"

//#region "Persons logic"
    const pickPerson = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setPersonSelectionVisibility(true);
    };

    const searchPersonList  = useMemo(() => {
        let entirePersonList = [...personList, ...regPersonList];

        if (personIds.length === 0) {
            return entirePersonList
                .filter((x) => { return (x.FirstName + ' ' + x.LastName)
                                            .toLowerCase()
                                            .indexOf(searchPerson.toLowerCase()) > -1; })
                .map((x) => {
                    return { FullName: (x.FirstName !== null ? x.FirstName : "") 
                                    + ' ' 
                                    + (x.LastName !== null ? x.LastName : "")
                                    + (x.ClientID.toString() !== clientId ? " (Reg)" :""), 
                            Id: x.PersonID,
                            IsReg: x.IsReg };})
                .slice(0, 5);
        }
        else {
            let listToReturn = entirePersonList
                .filter((x) => { return personIds.map(x => x.ID).includes(x.PersonID) })
                .map((x) => {
                    return { FullName: (x.FirstName !== null ? x.FirstName : "") 
                                + ' ' 
                                + (x.LastName !== null ? x.LastName : "")
                                + (x.ClientID.toString() !== clientId ? " (Reg)" :""), 
                             Id: x.PersonID,
                             IsReg: x.IsReg }});

            let numberToBeReturned:number = 5 - personIds.length;
            let remainedList = entirePersonList
                .filter((x) => { return !personIds.map(x => x.ID).includes(x.PersonID)
                                    && (x.FirstName + ' ' + x.LastName).toLowerCase().indexOf(searchPerson.toLowerCase()) > -1 })
                .map((x) => {
                    return { FullName: 
                                (x.FirstName !== null ? x.FirstName : "") 
                                + ' ' 
                                + (x.LastName !== null ? x.LastName : "")
                                + (x.ClientID.toString() !== clientId ? " (Reg)" :""), 
                            Id: x.PersonID,
                            IsReg: x.IsReg };})
                .slice(0, numberToBeReturned);

            remainedList.forEach(element => {
                listToReturn.push(element);
            });

            return listToReturn;
        }
    },[searchPerson, personList, personIds, regPersonList, clientId]);

    const closeSearchPerson = () => {
        FixSelectedPersonName(personIds.map(x => x.ID));
        if (personIds.length === 1 && boatIds.length === 0) {
            loadBoatForPerson(personIds[0].ID);
        }
        setSearchPerson('');
        setPersonSelectionVisibility(false);
    }

    const FixSelectedPersonName = (_personIds : number[]) => {
        let entirePersonList = [...personList, ...regPersonList];
        let _selectedPersonName = '';
        if (_personIds.length === 0)
            _selectedPersonName = 'Select person';
        else if (_personIds.length === 1) {
            let _person = entirePersonList.find((x) => x.PersonID?.toString() === _personIds[0]?.toString());
            _selectedPersonName = (_person?.FirstName !== null ? _person?.FirstName : "")
                                    + ' ' 
                                    + (_person?.LastName !== null ? _person?.LastName : "");
        }
        else
            _selectedPersonName = _personIds.length.toString() + ' persons selected';

        setSelectedPersonName(_selectedPersonName);
    }
    
    const singlePersonIdSelect = (e:any) => {
        if (e.detail.value.length === 0) return;
        let _value = Number(e.detail.value);
        let _fullName = "";
        let _isLocal = true;

        let _searchedPerson = searchPersonList.find((x) => x.Id === _value);
        if (_searchedPerson) {
            _fullName =  _searchedPerson.FullName;
            if (_searchedPerson.IsReg && _searchedPerson.IsReg === true)
                _isLocal = false;
            else
                _isLocal = true;
        }

        let item:ILocalIdentifierPerson = {ID:_value, IsLocal:_isLocal, ActivityLogRoleID: null, Name: _fullName} ;
        //setSinglePersonId([item]);
        setPersonIds([item]);
        FixSelectedPersonName([_value]);
        setSearchPerson('');
        setPersonSelectionVisibility(false);
    }

    const personSelect = (e:any, fullName:string) => {
        let _value = Number(e.detail.value);
        let newList:ILocalIdentifierPerson[] = personIds;
        if (e.detail.checked) {
            let foundId = personIds.find((x)=> x.ID ===_value);
            if (!foundId) {
                let _isLocal = true;
                let _fullName = fullName;
                
                let _searchedPerson = searchPersonList.find((x) => x.Id === _value);
                if (_searchedPerson) {
                    _fullName =  _searchedPerson.FullName;
                    if (_searchedPerson.IsReg && _searchedPerson.IsReg === true)
                        _isLocal = false;
                    else
                        _isLocal = true;
                }

                let newList:ILocalIdentifierPerson[] = personIds;
                newList.push({ID:_value, IsLocal:_isLocal, ActivityLogRoleID: null, Name: _fullName} );
                setPersonIds(newList);
            }
        }
        else {
            let index = newList.map(x => x.ID).indexOf(_value);
            if (index > -1) {
                newList.splice(index, 1);
                setPersonIds(newList);
            }
        }
    }

    const showPersonAdd = () => {
        setPersonAddVisibility(true);
    }

    const addPerson = () => {
        setShowLoadingSave(true);
        let personToSave:IPerson_Request = {
            PersonID: 0,
            ClientID: Number(clientId),
            FirstName: personFirstName,
            LastName: personLastName,
            DateOfBirth: personBirthDate === "" ? null : personBirthDate,
            // LocalState: personLocalState,
            // LocalCity: personLocalCity,
            // LocalZipCode: personLocalZipCode,
            EmailAddress: personEmail,
            PhoneHome: personPrimaryPhone,
            MailingStreet: personMailingStreet,
            MailingState: personMailingState,
            MailingCity: personMailingCity,
            MailingZipCode: personMailingZipCode
        };

        let personToSearch = personFirstName + ' ' + personLastName;
        if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) {
            setShowLoadingSave(true);
            let storedToken = window.localStorage.getItem("token");
            let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
            if (expireTokenDate > new Date()) {
                new DataAccessService()
                    .putPerson(String(storedToken), JSON.stringify(personToSave))
                        .then(
                            function(expectedData:any) {
                                if (expectedData) {
                                    let personListDB = (JSON.parse(expectedData.toString()) as IPerson_Response).Persons;
                                    if (personListDB.length === 1) {
                                        let objPersonList = JSON.parse(String(window.localStorage.getItem("persons")));
                                        if (!objPersonList) objPersonList = [];
                                        objPersonList.push(personListDB[0]);
                                        window.localStorage.setItem("persons", JSON.stringify(objPersonList));
                                        setStoragePersons(String(window.localStorage.getItem("persons")));  
                                        if (type !== "3") { //if it's single select it should close all the modals and go to the main view
                                            let item:ILocalIdentifierPerson = {
                                                    ID:personListDB[0].PersonID, 
                                                    IsLocal:false, 
                                                    ActivityLogRoleID: null, 
                                                    Name: personListDB[0].FirstName + " " + personListDB[0].LastName} ;
                                                    
                                            setPersonIds([item]);
                                            setSelectedPersonName(item.Name);
                                            setSearchPerson('');
                                            setShowLoadingSave(false);
                                            clearAddPersonForm();
                                            setPersonAddVisibility(false);
                                            setPersonSelectionVisibility(false); 
                                        }
                                        else {
                                            setShowLoadingSave(false);
                                            clearAddPersonForm();
                                            setSearchPerson(personToSearch);
                                            setPersonAddVisibility(false);
                                        }
                                    }
                                    else {
                                        setShowLoadingSave(false);
                                        clearAddPersonForm();
                                        setSearchPerson(personToSearch);
                                        setPersonAddVisibility(false);
                                    }
                                }
                                else {
                                    setShowLoadingSave(false);
                                    clearAddPersonForm();
                                    setSearchPerson(personToSearch);
                                    setPersonAddVisibility(false); 
                                }
                            },
                            function (response) {
                                setShowLoadingSave(false);
                                clearAddPersonForm();
                                setPersonAddVisibility(false);
                            }
                        );
            }
            else {
                setShowLoadingSave(false);
                clearAddPersonForm();
                setPersonAddVisibility(false);
            }
        }
    }

    const clearAddPersonForm = () => {
        setPersonFirstName('');
        setPersonLastName('');
        setPersonBirthDate('');
        // setPersonLocalState('');
        // setPersonLocalCity('');
        // setPersonLocalZipCode('');
        setPersonEmail('');
        setPersonPrimaryPhone('');
        setPersonMailingState('');
        setPersonMailingCity('');
        setPersonMailingZipCode('');
        setPersonMailingStreet('');
    }

    const closeAddPerson = () => {
        setPersonAddVisibility(false);
    }

    const loadBoatForPerson = async(_personID:number) => {
        let _responseBoatId = await getBoatForPerson(_token, _personID.toString(), clientId);
        if (_responseBoatId) {
            let listboats = JSON.parse(storageBoats) as IBoatInfo[];
            let foundBoat = listboats.find((x) => x.BoatID.toString() === _responseBoatId);
            if (foundBoat) {
                setBoatIds([{ID:foundBoat.BoatID, IsLocal: !(foundBoat.IsReg === true)}]);
                FixSelectedVesselName([foundBoat.BoatID]);
            }
        }
    }
//#endregion "Persons Logic"

 //#region "Users logic"
    const pickUser= () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setUserSelectionVisibility(true);
    };

    const searchUserList  = useMemo(() => {
        if (userIds.length === 0) { 
            return userList
                    .filter((x) => { return (x.DisplayName).toLowerCase().indexOf(searchUser.toLowerCase()) > -1; })
                    .map((x) => {
                        return { FullName: x.DisplayName, Id: x.UserID };})
                    .slice(0, 5);
        }
        else {
            let listToReturn = userList
                    .filter((x) => { return userIds.includes(x.UserID)})
                    .map((x) => {
                        return { FullName: x.DisplayName, Id: x.UserID };});

            let numberToBeReturned:number = 6;             
            let remainedList = userList
                    .filter((x) => { return !userIds.includes(x.UserID)
                                        && (x.DisplayName).toLowerCase().indexOf(searchUser.toLowerCase()) > -1 })
                    .map((x) => {
                        return { FullName: x.DisplayName, Id: x.UserID };})
                    .slice(0, numberToBeReturned);

            remainedList.forEach(element => { listToReturn.push(element); });
            return listToReturn;
        }
    },[searchUser, userList, userIds]);

    const closeSearchUser = () => {
        FixSelectedUserName(userIds);
        setSearchUser('');
        setUserSelectionVisibility(false);
    }

    const FixSelectedUserName = (_userIds : string[]) => {
        let _selectedUserName = '';
        if (_userIds.length === 0)
            _selectedUserName = 'Select staff person';
        else if (_userIds.length === 1) {
            let _user = userList.find((x) => x.UserID.toLowerCase() === _userIds[0]?.toString().toLowerCase());
            _selectedUserName = _user ? _user.DisplayName : "";
        }
        else
            _selectedUserName = _userIds.length.toString() + ' staff persons selected';
        setSelectedUserName(_selectedUserName);
    }
    
    const singleUserIdSelect = (e:any) => {
        let _value = e.detail.value;
        setSingleUserId(_value);
        setUserIds([_value]);
        FixSelectedUserName([_value]);
        setSearchUser('');
        setUserSelectionVisibility(false);
    }

    const userSelect = (e:any) => {
        debugger;
        let _value = String(e.detail.value);
        let newList:string[] = userIds;
        
        if (e.detail.checked) {
            let foundId = userIds.find((x)=> x ===_value);
            if (!foundId) {
                newList.push(_value);
                setUserIds(newList);
            }
        }
        else {
            let index = newList.indexOf(_value);
            if (index > -1) {
                newList.splice(index, 1);
                setUserIds(newList);
            }
        } 
    }

  //#endregion "Users Logic"

//#region "Offenses logic"
    const pickOffense = () => {
        debugger;
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setOffenseSelectionVisibility(true);
    };

    const searchOffenseList  = useMemo(() => {
        if (offenses.length === 0) {
            return violationTypeList
                .filter((x) => { return (x.Comments && x.Comments !== "" ? x.Comments : x.Description).toLowerCase().indexOf(searchOffense.toLowerCase()) > -1; })
                .map((x) => {
                    return { FullName: (x.Comments && x.Comments !== "" ? x.Comments : x.Description), 
                             Id: x.ViolationTypeID, 
                             IsFromList: true, 
                             ActivityTypeViolationID: null};})
                .slice(0, 6);
        }
        else {
            let listToReturn:any[] = [];
            let offenseIds = offenses.map((o) => { return o.ViolationTypeID});
            offenses.forEach((x) => {
                if (!x.ViolationTypeID) 
                    listToReturn.push({ FullName: x.Description, 
                                        Id: null, 
                                        IsFromList: false, 
                                        ActivityTypeViolationID: x.ActivityLogViolationID});
                else {
                    let itemFromList = violationTypeList.find((y) => y.ViolationTypeID === x.ViolationTypeID?.valueOf());
                    if (itemFromList)
                        listToReturn.push(
                            {   FullName:  (itemFromList.Comments && itemFromList.Comments !== "" ? itemFromList.Comments : itemFromList.Description),
                                Id: itemFromList.ViolationTypeID, 
                                IsFromList:true, 
                                ActivityTypeViolationID:x.ActivityLogViolationID});
                }
                    
            });

            let numberToBeReturned:number = 6 - offenses.length;
            let remainedList = violationTypeList
                .filter((x) => { return !offenseIds.includes(x.ViolationTypeID)
                                    && (x.Comments && x.Comments !== "" ? x.Comments : x.Description).toLowerCase().indexOf(searchOffense.toLowerCase()) > -1 })
                .map((x) => {
                    return { FullName: (x.Comments && x.Comments !== "" ? x.Comments : x.Description), 
                             Id: x.ViolationTypeID, 
                             IsFromList:true,
                             ActivityTypeViolationID: null };})
                .slice(0, numberToBeReturned);

            remainedList.forEach(element => {
                listToReturn.push(element);
            });
            return listToReturn;
        }
    },[searchOffense, violationTypeList, offenses]);

    const closeSearchOffense = () => {
        FixSelectedOffenseName(offenses);
        setSearchOffense('');
        setOffenseSelectionVisibility(false);
        calculateFee(warning, offenses);
    }

    const FixSelectedOffenseName = (_offenses : IViolationInfo[]) => {
        let _selectedOffenseName = '';
        if (_offenses.length === 0)
            _selectedOffenseName = 'Select offense';
        else if (_offenses.length === 1) {
            if (!_offenses[0].ViolationTypeID) {
                let _offense = violationTypeList.find((x) => x.ViolationTypeID?.toString() === _offenses[0]?.ViolationTypeID?.toString());
                _selectedOffenseName = _offense ? _offense.Comments : _offenses[0].Description.substring(0, 50);
            }
            else
                _selectedOffenseName = _offenses[0].Description.substring(0, 50);
        }
        else
            _selectedOffenseName = _offenses.length.toString() + ' offenses selected';
        setSelectedOffenseName(_selectedOffenseName);
    }

    const offenseSelect = (e:any, offenseItem:any) => {
        if (!offenseSelectionVisibility) return;
        if (e.detail.checked) {
            if (offenseItem.Id) {
                if (offenseItem.ActivityTypeViolationID) {
                    let foundId = offenses.find((x)=> x.ActivityLogViolationID === offenseItem.ActivityTypeViolationID);
                    if (!foundId) {
                        let violationTypeItem = violationTypeList.find((v) => v.ViolationTypeID === offenseItem.Id);
                        if (violationTypeItem) {
                            let newList:IViolationInfo[] = offenses;
                            let item:IViolationInfo =  new ViolationInfo(offenseItem.ActivityTypeViolationID, offenseItem.Id, violationTypeItem.Description, violationTypeItem.Fee);
                            newList.push(item);
                            setOffenses(newList);
                        }
                    }
                }
                else {
                    let foundId = offenses.find((x)=> x.ViolationTypeID === offenseItem.ID);
                    if (!foundId) {
                        let violationTypeItem = violationTypeList.find((v) => v.ViolationTypeID === offenseItem.Id);
                        if (violationTypeItem) {
                            let newList:IViolationInfo[] = offenses;
                            let item:IViolationInfo =  new ViolationInfo(offenseItem.ActivityTypeViolationID, offenseItem.Id, violationTypeItem.Description, violationTypeItem.Fee);
                            newList.push(item);
                            setOffenses(newList);
                        }
                    }
                }
            }
        }
        else {
            //setOffenseSelectionVisibility(false);
            if (offenseItem.ActivityTypeViolationID) {
                let newRemovedList:IViolationInfo[] = offenses.filter((x) => x.ActivityLogViolationID !== offenseItem.ActivityTypeViolationID);
                setOffenses(newRemovedList);
            }
            else {
                let newRemovedList:IViolationInfo[] = offenses.filter((x) => x.ViolationTypeID !== offenseItem.ID);
                setOffenses(newRemovedList);
            }
            //pickOffense();
            //setOffenseSelectionVisibility(true);
        }
        //console.log({"list": searchOffenseList});
    }

    const calculateFee = (_warning:boolean, _offenses:IViolationInfo[]) => {
        if (_warning)
            setFee('$0.00');
        else {
            let valueToReturn = 0;
            if (_offenses) {
                _offenses.forEach((el) => {
                    valueToReturn += (el.Fee || 0);
                });
            }
            setFine(valueToReturn);
            setFee('$' + valueToReturn.toString()); 
        }
    }

    const showOffenseAdd = () => {
        setOffenseSelectionVisibility(false);
        setOffenseAddVisibility(true);
    }

    const addOffense = () => {
        //setShowLoadingSave(true);
        let item:IViolationInfo =  new ViolationInfo(0, null, offenseDescription, offenseFine);
        setOffenses([...offenses, item]);
        clearAddOffenseForm();
        setOffenseAddVisibility(false);
        setOffenseSelectionVisibility(true);
        console.log({"list": searchOffenseList});
    }

    const clearAddOffenseForm = () => {
        setOffenseDescription("");
        setOffenseFine(0);
    }

    const closeAddOffense = () => {
        setOffenseAddVisibility(false);
        setOffenseSelectionVisibility(true);
    }
//#endregion "Offenses Logic"

//#region "GAR"
    const pickGAR = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setGarSelectionVisibility(true);
    };

    const addGARScore = () => {
        let total = supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity;
         if (total < 24) {
            //setGarColor("my-toolbar-green");
            setGarColorLabel("my-ion-item-green");
        }
        else if (total < 45) {
            //setGarColor("my-toolbar-yellow");
            setGarColorLabel("my-ion-item-yellow");
        }
        else {
            //setGarColor("my-toolbar-red");
            setGarColorLabel("my-ion-item-red");
        }
        setSelectedGARName("Total GAR Score " + total.toString());
        if (gar) {
            setGar({...gar,
                    ...{Supervision: supervision,
                        Planning: planning,
                        CrewSelection: crewSelection,
                        Endurance: crewEndurance,
                        Weather: garWeather,
                        CaseComplexity: caseComplexity,
                        Total:total}
            });
        }
        else
            setGar(new GARInfo(0,
                        supervision,
                        planning,
                        crewSelection,
                        crewEndurance,
                        garWeather,
                        caseComplexity,
                        total));

        setGarSelectionVisibility(false);
    }

    const setGARItem = (e:any, type:string) => {
        switch (type) {
            case "supervision":
                setSupervision(Number(e.detail.value!));
                break;
            case "planning":
                setPlanning(Number(e.detail.value!));
                break;
            case "crewSelection":
                setCrewSelection(Number(e.detail.value!));
                break;
            case "crewEndurance":
                setCrewEndurance(Number(e.detail.value!));
                break;
            case "garWeather":
                setGarWeather(Number(e.detail.value!));
                break;
            case "caseComplexity":
                setCaseComplexity(Number(e.detail.value!));
                break;
            default:
                break;
        }
        let total = supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity;

        if (total < 24) {
            setGarColor("my-toolbar-green");
            setGarColorLabel("my-ion-item-green");
        }
        else if (total < 45) {
            setGarColor("my-toolbar-yellow");
            setGarColorLabel("my-ion-item-yellow");
        }
        else {
            setGarColor("my-toolbar-red");
            setGarColorLabel("my-ion-item-red");
        }
    }

//#endregion "Persons Logic"

//#region "Vehicle Logic"
    const pickVehicle = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setVehicleSelectionVisibility(true);
    }

    const searchVehicleList  = useMemo(() => {
        if (vehicleIds.length === 0) {
            return vehicleList
                .filter((x) => { return x.LicensePlate !== null && (x.LicensePlate).indexOf(searchVehicle) >-1; })
                .map((x) => {
                    return { FullName: x.LicensePlate, Id: x.VehicleID };})
                .slice(0, 5);
        }
        else {
            let listToReturn = vehicleList
                .filter((x) => { return vehicleIds.includes(x.VehicleID) })
                .map((x) => {
                    return { FullName: x.LicensePlate, Id: x.VehicleID };});

            let numberToBeReturned:number = 5 - vehicleIds.length;
            let remainedList = vehicleList
                .filter((x) => { return !vehicleIds.includes(x.VehicleID)
                                    && (x.LicensePlate) 
                                    && (x.LicensePlate).toLowerCase().indexOf(searchVehicle.toLowerCase()) > -1 })
                .map((x) => {
                    return { FullName: x.LicensePlate, Id: x.VehicleID };})
                .slice(0, numberToBeReturned);

            remainedList.forEach(element => {
                listToReturn.push(element);
            });
            return listToReturn;
        }
    },[searchVehicle, vehicleList, vehicleIds]);

    const closeSearchVehicle = () => {
        FixSelectedVehicleName(vehicleIds);
        setSearchVehicle('');
        setVehicleSelectionVisibility(false);
    }

    const FixSelectedVehicleName = (_vehicleIds : number[]) => {
        let _selectedVehicleName= '';
        if (_vehicleIds.length === 0)
            _selectedVehicleName = 'Select vehicle';
        else if (_vehicleIds.length === 1) {
            let _vehicle = vehicleList.find((x) => x.VehicleID.toString() === _vehicleIds[0]?.toString());
            _selectedVehicleName = (_vehicle) ? _vehicle.LicensePlate : '';
        }
        else
            _selectedVehicleName = _vehicleIds.length.toString() + ' vehicles selected';

        setSelectedVehicleName(_selectedVehicleName);
    }

    const vehicleSelect = (e:any) => {
        if (isNaN(e.detail.value)) return;

        let _value = Number(e.detail.value);
        let newList:number[] = vehicleIds;
        if (e.detail.checked) {
            let foundId = vehicleIds.find((x)=> x ===_value);
            if (!foundId) {
                let newList:number[] = vehicleIds;
                newList.push(_value);
                setVehicleIds(newList);
            }
        }
        else {
            let index = newList.indexOf(_value);
            if (index > -1) {
                newList.splice(index, 1);
                setVehicleIds(newList);
            }
        }
    }

    const singleVehicleIdSelect = (e:any) => {
        if (isNaN(e.detail.value)) return;
        
        let _value = Number(e.detail.value);;
        setSingleVehicleId([_value]);
        setVehicleIds([_value]);
        FixSelectedVehicleName([_value]);
        setSearchVehicle('');
        setVehicleSelectionVisibility(false);
    }

    const showVehicleAdd = () => {
        setVehicleAddVisibility(true);
    }

    const addVehicle = () => {
        setShowLoadingSave(true);
        let vehicleToSave: IPutVehicle_Request = {
            VehicleID: 0,
            ClientID: Number(clientId),
            LicensePlate: vehicleLicensePlate
        };

        let vehicleToSearch = vehicleLicensePlate;
        if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) {
            setShowLoadingSave(true);
            let storedToken = window.localStorage.getItem("token");
            let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
            if (expireTokenDate > new Date()) {
                new DataAccessService()
                    .putVehicle(String(storedToken), JSON.stringify(vehicleToSave))
                        .then(
                            function(expectedData:any) {
                                if (expectedData) {
                                    let vehicleListDB = (JSON.parse(expectedData.toString()) as IVehicle_Response).Vehicles;
                                    if (vehicleListDB.length === 1) {
                                        let objVehicleList = JSON.parse(String(window.localStorage.getItem("vehicles")));
                                        if (!objVehicleList)
                                            objVehicleList = [];
                                        objVehicleList.push(vehicleListDB[0]);
                                        window.localStorage.setItem("vehicles", JSON.stringify(objVehicleList));
                                        setStorageVehicles(String(window.localStorage.getItem("vehicles")));    
                                    }
                                }
                                setShowLoadingSave(false);
                                clearAddVehicleForm();
                                setSearchVehicle(vehicleToSearch);
                                setVehicleAddVisibility(false);
                            },
                            function (response) {
                                setShowLoadingSave(false);
                                clearAddVehicleForm();
                                setVehicleAddVisibility(false);
                            }
                        );
            }
            else {
                setShowLoadingSave(false);
                clearAddVehicleForm();
                setVehicleAddVisibility(false);
            }
        }
    }

    const clearAddVehicleForm = () => {
        setVehicleLicensePlate('');
    }

    const closeAddVehicle = () => {
        setVehicleAddVisibility(false);
    }

//#endregion "Vehicle Logic"

//#region "Coordinates"
    const pickCoordinates = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else {
            if (activityLogLatitude === null || activityLogLongitude === null) {
                let _clients = JSON.parse(String(window.localStorage.getItem("clients"))) as IClient[];
                let _currentClient = _clients.find((x) => x.ClientID.toString() === clientId);
                console.log(_currentClient);
                let _latitude: number|null;
                if (myContext &&  myContext.latitude)
                    _latitude = myContext.latitude;
                else
                    _latitude = _currentClient &&  _currentClient.MaxLatitude ?  _currentClient.MaxLatitude : null;

                let _longitude: number|null;
                if (myContext && myContext.longitude)
                    _longitude = myContext.longitude
                else
                    _longitude = _currentClient && _currentClient.MaxLongitude ? _currentClient.MaxLongitude : null; 

                setActivityLogLatitude(_latitude);
                setActivityLogLongitude(_longitude);
                setTempLatitude(_latitude);
                setTempLongitude(_longitude);
            }
            setMapVisibility(true); 
        }
    };

    const addCoordinates = () => {
        setActivityLogLatitude(tempLatitude);
        setActivityLogLongitude(tempLongitude);
        setMapVisibility(false);
    };

    const cancelCoordinates = () => {
        setMapVisibility(false);
    };

    const getChangedCoordinates = (_position:any) => {
        if (_position) {
            setTempLatitude(_position.lat);
            setTempLongitude(_position.lng);
        }
    };

    const FixSelectedCoordinates = () => {
        if (activityLogLatitude === null || activityLogLongitude === null)
            return '';
        if (activityLogLatitude !== null && activityLogLongitude !== null)
            return activityLogLatitude.toString() + ' , ' + activityLogLongitude.toString();
    }

//#endregion

//#region "Pre-Post Inspection Logic"
    var valueBooleanNull:boolean|null = null;
    var valueNumberNull:number|null = null;
    var valueStringNull:string|null = null;

    const selectedPrePostInspections = useMemo(() => {
        let filteredOrderedList = equipmentInspectionPointList
                .filter((x) => isPreInspection ? x.PreInspection : x.PostInspection)
                .sort((a,b) => { if (a.Ordinal < b.Ordinal) return -1;
                                 if (a.Ordinal > b.Ordinal) return 1;
                                   return 0;
                                });
        let listToReturn = filteredOrderedList.map((x) => {
            return (
                {
                    EquipmentInspectionPointID: x.EquipmentInspectionPointID,
                    EquipmentTypeID: x.EquipmentTypeID,
                    PreInspection: x.PreInspection,
                    PostInspection: x.PostInspection,
                    Description: x.Description,
                    DataType: x.DataType,
                    Ordinal: x.Ordinal,
                    ValueString: valueStringNull,
                    ValueInt: valueNumberNull,
                    ValueBoolean: valueBooleanNull,
                    ValueDecimal2: valueNumberNull
                }
            )
        });

        if (equipmentInspectionPoints.length > 0 ){
            listToReturn.forEach(element => {
                let founded = equipmentInspectionPoints.find((x) => x.EquipmentInspectionPointID === element.EquipmentInspectionPointID && x.PreOrPost === (isPreInspection ? false : true));
                if (founded) {
                    element.ValueBoolean = founded.ValueBoolean;
                    element.ValueDecimal2 = founded.ValueDecimal2;
                    element.ValueInt = founded.ValueInt;
                    element.ValueString = founded.ValueString;
                }
            });
        }
        return listToReturn;
    }, [isPreInspection, equipmentInspectionPoints, valueBooleanNull, valueStringNull, valueNumberNull, equipmentInspectionPointList]);


    const setPrePostInspectionTextInit = (_list:IEquipmentInspectionPointInfo[]) => {
        let listPreInspection = _list.filter((x) => x.PreOrPost === false);
        if (listPreInspection.length > 0)
            setPreInspectionText("Filled in");
        else
            setPreInspectionText("No data");

        let listPostInspection = _list.filter((x) => x.PreOrPost === true);
        if (listPostInspection.length > 0)
            setPostInspectionText("Filled in");
        else
            setPostInspectionText("No data");   
    }

    const setPrePostInspectionText = (_list:IEquipmentInspectionPointInfo[]) => {
        let listInspectionsPre = _list.filter((x) => x.PreOrPost === false).map((i:IEquipmentInspectionPointInfo) => {return i.EquipmentInspectionPointID});
        let filteredListPre = equipmentInspectionPointList
                            .filter((eq:IEquipmentInspectionPointItem) => listInspectionsPre.includes(eq.EquipmentInspectionPointID));
        let listPreInspection = filteredListPre.filter((eq:IEquipmentInspectionPointItem) => eq.PreInspection);
        if (listPreInspection.length > 0)
            setPreInspectionText("Filled in");
        else
            setPreInspectionText("No data");

        let listInspectionsPost = _list.filter((x) => x.PreOrPost === true).map((i:IEquipmentInspectionPointInfo) => {return i.EquipmentInspectionPointID});
        let filteredListPost = equipmentInspectionPointList
                                .filter((eq:IEquipmentInspectionPointItem) => listInspectionsPost.includes(eq.EquipmentInspectionPointID));
        let listPostInspection = filteredListPost.filter((eq:IEquipmentInspectionPointItem) => eq.PostInspection);
        if (listPostInspection.length > 0)
            setPostInspectionText("Filled in");
        else
            setPostInspectionText("No data");
    }

    const pickPreInspection = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else {
            setIsPreInspection(true);
            setPreInspectionVisibility(true);
        }
    }

    const pickPostInspection = () => {
        if (clientId === '0') {
            let messageToDisplay = "Please select a Harbor first";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else {
            setIsPreInspection(false);
            setPostInspectionVisibility(true); 
        }
    }

    const savePrePostInspection = () => {
        setPrePostInspectionText(equipmentInspectionPoints);
        setPreInspectionVisibility(false);
        setPostInspectionVisibility(false);
    }

    const backPrePostInspection = () => {
        setPreInspectionVisibility(false);
        setPostInspectionVisibility(false);
    }

    const inspectionPointChange = (e:any, type:string, id:number, isPre:boolean) => {
        let foundItem: IEquipmentInspectionPointInfo|undefined = equipmentInspectionPoints.find((x)=> x.EquipmentInspectionPointID === id && x.PreOrPost === (isPre ? false : true));
        
        if (type === "boolean") {
            let _value = e.detail.checked
            if (foundItem) {
                
                let newList:IEquipmentInspectionPointInfo[] = equipmentInspectionPoints;
                let foundItemIndex = equipmentInspectionPoints.indexOf(foundItem);
                newList.splice(foundItemIndex, 1);

                foundItem.ValueBoolean = _value;
                newList.push(foundItem);
                setEquipmentInspectionPoints(newList);
            }
            else {
                let newList:IEquipmentInspectionPointInfo[] = equipmentInspectionPoints;
                let item: IEquipmentInspectionPointInfo = new EquipmentInspectionPointInfo(
                   id, (isPre ? false : true), valueStringNull, valueNumberNull, _value, valueNumberNull);
                newList.push(item);
                setEquipmentInspectionPoints(newList);
            }
        }

        if (type === "decimal2") {
            let _value = e.detail.value;
            if (foundItem) {
               
                let newList:IEquipmentInspectionPointInfo[] = equipmentInspectionPoints;
                let foundItemIndex = equipmentInspectionPoints.indexOf(foundItem);
                newList.splice(foundItemIndex, 1);

                foundItem.ValueDecimal2 = _value;
                newList.push(foundItem);
                setEquipmentInspectionPoints(newList);
            }
            else
            {
                let newList:IEquipmentInspectionPointInfo[] = equipmentInspectionPoints;
                let item: IEquipmentInspectionPointInfo = new EquipmentInspectionPointInfo(
                   id, (isPre ? false : true), valueStringNull, valueNumberNull, valueBooleanNull, _value);
                newList.push(item);
                setEquipmentInspectionPoints(newList);
            }
        }
    }
//#endregion "Pre-Post Inspection Logic"

//#region "Images"
    const pickCamera = () => {
        if (stateActivityId === '0'){
            let messageToDisplay = "Please first save the Activity";
            setToastMessage(messageToDisplay);
            setShowToast(true);
        }
        else
            setImagesVisibility(true);
    }

    const saveImages = () => {
        let selectedText = getImagesText(images);
        setSelectedImagesSummary(selectedText);
        setImagesVisibility(false);
    }

    const getImagesText = (_photos:Photo[]) => {
        let selectedText ='';
        let photosNo = _photos.length;
        switch (photosNo) {
            case 0:
                selectedText = "No images selected";
                break;
            case 1:
                selectedText = "One image selected";
                break;
            default:
                selectedText = photosNo.toString() + " images selected";
                break;
        }
        return selectedText;
    }

    const onPhotoTaken = (_token:string, activityId:string, _clientId:string) => {
        debugger;
        takePhoto(_token, Number(activityId), Number(_clientId));
    }

    const removeImage = (_image:Photo) => {
        if (_image.photoId){
            let remainingImages = initialImages.filter((x) => x.filepath !== _image.filepath);
            setInitialImages(remainingImages);
        }
        else
            deletePhoto(_image);
    }

    const enlargeImage = (_image:Photo) => {
        setFullPhoto(_image);
        setFullImageVisibility(true);
    }
//#endregion "Images"

//#region  "Save Logic"
    const checkForSave = (_currentActivityLog: IActivityLogResult_Response["Result"] ) : boolean => {
        let valueToReturn = true;
        let messageToDisplay = "";
        switch (type) {
            case '1':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (activityTypeListVisible && _currentActivityLog.ActivityType === ''){
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Work Type";
                    else
                        messageToDisplay ="select a Work Type";
                    valueToReturn = false;
                }if (_currentActivityLog.DateEnding !== '' && _currentActivityLog.DeliveryDate === ''){
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and fill in the Delivery Date";
                    else
                        messageToDisplay ="fill in the Delivery Date";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!"
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '2':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (activityTypeListVisible && _currentActivityLog.ActivityType === ''){
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Work Type";
                    else
                        messageToDisplay ="select a Work Type";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '3':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (locationListVisible && _currentActivityLog.Location === ''){
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Location";
                    else
                        messageToDisplay ="select a Location";
                        valueToReturn = false;
                }
                if (categoryListVisible && _currentActivityLog.Category === ''){
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Category";
                    else
                        messageToDisplay ="select a Category";
                        valueToReturn = false;
                }
                // if (weatherSource === '') {
                //     if (messageToDisplay !== "")
                //         messageToDisplay = messageToDisplay + " and add the Weather Source";
                //     else
                //         messageToDisplay = "add the Weather Source";
                //     valueToReturn = false;
                // }
                // if (weatherId === null || weatherId === 0) {
                //     if (messageToDisplay !== "")
                //         messageToDisplay = messageToDisplay + " and select a Weather Type";
                //     else
                //         messageToDisplay = "select a Weather Type";
                //     valueToReturn = false;
                // }
                // if (windId === null || windId === 0) {
                //     if (messageToDisplay !== "")
                //         messageToDisplay = messageToDisplay + " and select a Wind Type";
                //     else
                //         messageToDisplay = "select a Wind Type";
                //     valueToReturn = false;
                // }
                // if (seasId === null || seasId === 0) {
                //     if (messageToDisplay !== "")
                //         messageToDisplay = messageToDisplay + " and select a Sea Type";
                //     else
                //         messageToDisplay = "select a Sea Type";
                //     valueToReturn = false;
                // }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '4':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (equipmentStatusId === null || equipmentStatusId === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select an Equipment Status";
                    else
                        messageToDisplay = "select an Equipment Status";
                    valueToReturn = false;
                }
                if (equipmentList.length > 0 && (equipmentId === null || equipmentId === 0)) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select an Equipment";
                    else
                        messageToDisplay = "select an Equipment";
                    valueToReturn = false;
                }
                if (selectedPrePostInspections.length > 0 && preInspectionText === "No data") {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and fill in PreInspection";
                    else
                        messageToDisplay = "fill in PreInspection";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '5':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                // if (locationListVisible && _currentActivityLog.Location === ''){
                //     if (messageToDisplay !== "")
                //         messageToDisplay = messageToDisplay + " and select a Location";
                //     else
                //         messageToDisplay ="select a Location";
                //         valueToReturn = false;
                // }
                if (boatList.length > 0 && boatIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Vessel";
                    else
                        messageToDisplay = "select a Vessel";
                    valueToReturn = false;
                }
                if (quantity === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and fill in the Quantity";
                    else
                        messageToDisplay = "fill in the Quantity";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '6':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (locationListVisible && _currentActivityLog.Location === ''){
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Location";
                    else
                        messageToDisplay ="select a Location";
                    valueToReturn = false;
                }
                if (ticket === '') {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add a Ticket # number";
                    else
                        messageToDisplay ="add a Ticket # number";
                    valueToReturn = false;
                }
                if (offenses.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select Offense";
                    else
                        messageToDisplay ="select Offense";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '7':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '8':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (boatIds.length === 0 && boatList.length > 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and select a Vessel";
                    else
                        messageToDisplay = "select a Vessel";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            case '9':
                if (_currentActivityLog.ClientID === '0') {
                    messageToDisplay = "select a Harbor";
                    valueToReturn = false;
                }
                if (userIds.length === 0) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and add the Staff person";
                    else
                        messageToDisplay = "add the staff person";
                    valueToReturn = false;
                }
                if (!_currentActivityLog.GAR) {
                    if (messageToDisplay !== "")
                        messageToDisplay = messageToDisplay + " and fill in the GAR Score";
                    else
                        messageToDisplay = "fill in the GAR Score";
                    valueToReturn = false;
                }
                if (messageToDisplay !== "") {
                    messageToDisplay = "Please " + messageToDisplay + "!";
                }
                setToastMessage(messageToDisplay);
                return valueToReturn;

            default:
                return false;
        }
    }

    const fillInDataForSave = () => {
        let currentActivityLog = activityLog;
        if (stateActivityId !== '0') 
            currentActivityLog.ActivityLogID = Number(stateActivityId);
        else
            currentActivityLog.ActivityLogID = Number(activityId);

        currentActivityLog.ClientID = clientId;
        currentActivityLog.ActivityLogEntryTypeID = Number(type === "0" ? activityTypeId : type);

        if (startDate !== '') {
            if (startDate.indexOf('GMT') > -1 || startDate.indexOf('T') === -1) {
                let changedStartDate = formatDateTimeForSave(startDate);
                currentActivityLog.DateStarting = changedStartDate;
            }
            else
                currentActivityLog.DateStarting = startDate;
        }

        if (endDate !== '') {
            if (endDate.indexOf('GMT') > -1 || endDate.indexOf('T') === -1) {
                let changedEndDate = formatDateTimeForSave(endDate);
                currentActivityLog.DateEnding = changedEndDate;
            }
            else
                currentActivityLog.DateEnding = endDate;
        }

        currentActivityLog.Category = category;
        currentActivityLog.Location = locationA;
        currentActivityLog.Pinned = pinned;
        currentActivityLog.ActivityType = activityType;
        currentActivityLog.Comments = comments;
        currentActivityLog.Tide = tide;
        if (seasId !== null && seasId !== 0)
            currentActivityLog.SeasID =  seasId;
        if (windId !== null && windId !== 0)
            currentActivityLog.WindID = windId;
        if (weatherId !== null && weatherId !== 0)
            currentActivityLog.WeatherID = weatherId;
        currentActivityLog.Approved = approved;
        currentActivityLog.ApprovedBy = approvedBy;
        currentActivityLog.ConditionsSource = weatherSource;
        currentActivityLog.IncidentDispositionID = incidentDispositionId;

        currentActivityLog.Users = [];
        if (userIds.length > 0) {
            currentActivityLog.Users = userIds;
        }
        currentActivityLog.LoginID = userIds[0];

        currentActivityLog.Persons = [];
        if (personIds.length > 0) {
            currentActivityLog.Persons = personIds;
        }
        currentActivityLog.Vessels = [];
        if (boatIds.length > 0) {
            currentActivityLog.Vessels= boatIds;
            if (currentActivityLog.ActivityLogEntryTypeID === 8 && boatIds.length === 1)
                currentActivityLog.VesselLength = addedVesselLength;
        }
        currentActivityLog.Vehicles = [];
        if (vehicleIds?.length > 0) {
            currentActivityLog.Vehicles = vehicleIds;
        }
        currentActivityLog.InspectionPoints = [];
        if (equipmentInspectionPoints.length > 0) {
            currentActivityLog.InspectionPoints = equipmentInspectionPoints;
        }
        if (equipmentId) {
            currentActivityLog.EquipmentID = equipmentId;
        }
        if (equipmentStatusId) {
            currentActivityLog.EquipmentStatusID = equipmentStatusId;
        }
        if (gar) {
            currentActivityLog.GAR = gar;
        }
        currentActivityLog.Quantity = quantity;
        currentActivityLog.Warning = warning;
        currentActivityLog.IsPrivate = isPrivate;

        if (deliveryMethodId)
            currentActivityLog.DeliveryMethodID = deliveryMethodId;
        if (deliveryDate !== '')
            currentActivityLog.DeliveryDate = deliveryDate;

        currentActivityLog.Violations = [];
        if (offenses.length > 0) {
            currentActivityLog.Violations = offenses;
        }
        
        currentActivityLog.TicketNumber = ticket;
        
        if (fine || fee) {
            let feeToBeSaved : number;
            if (fee.indexOf("$") > -1) {
                feeToBeSaved = Number(fee.replace("$",""));
            }
            else if (fee !== "") {
                feeToBeSaved = Number(fee);
            }
            else {
                feeToBeSaved = fine;
            }
            currentActivityLog.Fine = feeToBeSaved;
        }

        currentActivityLog.SafetyChecks = [];
        if (safetyChecks.length > 0)
            currentActivityLog.SafetyChecks = safetyChecks;

        if (activityLogLatitude)
            currentActivityLog.Latitude = activityLogLatitude;

        if (activityLogLongitude) {
            currentActivityLog.Longitude = activityLogLongitude;
        }

        if (images && images.length > 0){
            let imageList: IActivityPhotoItem[] = [];
            images.forEach((item) => {
                if (!item.photoId)
                    imageList.push({PhotoID: 0, FileName: item.filepath, FileUrl: item.filepath });
                else
                    imageList.push({PhotoID: item.photoId, FileName: item.filepath, FileUrl: item.filepath })
            });
            currentActivityLog.Photos = imageList;
        }

         if (isExternal === "1") {
            if (_permitId !== "0")
                currentActivityLog.PermitID = Number(_permitId);
            if (_mooringId !== "0")
                currentActivityLog.MooringID = Number(_mooringId);
         }

        return currentActivityLog;
    }

    const save = () => {
        let currentActivityLogForsave = fillInDataForSave();
        if (!checkForSave(currentActivityLogForsave)) {
            setShowToast(true);
        }
        else {
            if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) {
                setShowLoadingSave(true);
                let storedToken = window.localStorage.getItem("token");
                let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
                if (expireTokenDate > new Date()) {
                    new DataAccessService()
                        .putActivityLog(String(storedToken), JSON.stringify(currentActivityLogForsave))
                            .then(
                                function (expectedData) {
                                    if (expectedData) {
                                        setStateActivityId(String(expectedData));
                                        //refresh the equipments in storage
                                        new DataAccessService().getEquipmentList(String(storedToken))
                                            .then (
                                                function (expectedData) {
                                                    if (expectedData) {
                                                        let equipmentListDB = (JSON.parse(expectedData.toString()) as IEquipment_Response).Equipments;
                                                        let equipments:IEquipmentInfo[] = [];
                                                        if (equipmentListDB.length !== 0) {
                                                            equipmentListDB.forEach((v, i) => equipments.push(v));
                                                            window.localStorage.setItem("equipments", JSON.stringify(equipments));
                                                        }
                                                    }
                                                    let _lusername = window.localStorage.getItem("username");

                                                    //refresh the boats in storage
                                                    window.localStorage.removeItem("boats");
                                                    new DataAccessService().getBoatList(String(storedToken))
                                                        .then(
                                                            function (expectedData) {
                                                                if (expectedData) {
                                                                    let boatListDB = (JSON.parse(expectedData.toString()) as IBoat_Response).Boats;
                                                                    let boats: IBoatInfo[] = [];
                                                                    if (boatListDB.length !== 0) {
                                                                        if (_lusername === "alinac" || _lusername === "bhurley")
                                                                            // filtering because general admininstrator
                                                                            boatListDB.filter((x) => x.ClientID === 1 || x.ClientID === 89 || x.ClientID === 35)
                                                                                        .forEach((v, i) => boats.push(v));
                                                                        else
                                                                            boatListDB.forEach((v, i) => boats.push(v));

                                                                        window.localStorage.setItem("boats", JSON.stringify(boats));
                                                                        setStorageBoats(String(window.localStorage.getItem("boats")));
                                                                    }
                                                                }
                                                                setShowLoadingSave(false);
                                                                // setMessagePopup('Save was successful!');
                                                                // setShowPopup(true);
                                                            },
                                                            function (response) {
                                                                setShowLoadingSave(false);
                                                                // setMessagePopup('Save was successful!');
                                                                // setShowPopup(true);
                                                            }
                                                        );
                                                    
                                                    //refresh the persons in storage
                                                    window.localStorage.removeItem("persons");
                                                    new DataAccessService().getPersonList(String(storedToken))
                                                        .then(
                                                            function (expectedData) {
                                                                if (expectedData) {
                                                                    let personListDB = (JSON.parse(expectedData.toString()) as IPerson_Response).Persons;
                                                                    let persons: IPersonInfo[] = [];
                                                                    if (personListDB.length !== 0) {
                                                                        if (_lusername === "alinac" || _lusername === "bhurley")
                                                                            // filtering because general admininstrator
                                                                            personListDB.filter((x) => x.ClientID === 1 || x.ClientID === 89 || x.ClientID === 35)
                                                                                .forEach((v, i) => persons.push(v));
                                                                        else
                                                                            personListDB.forEach((v, i) => persons.push(v));
                                                                        window.localStorage.setItem("persons", JSON.stringify(persons));
                                                                        setStoragePersons(String(window.localStorage.getItem("persons")));  
                                                                    }
                                                                }
                                                                setShowLoadingSave(false);
                                                                // setMessagePopup('Save was successful!');
                                                                // setShowPopup(true);
                                                            },
                                                            function (response) {
                                                                setShowLoadingSave(false);
                                                                // setMessagePopup('Save was successful!');
                                                                // setShowPopup(true);
                                                            }
                                                        );


                                                    setShowLoadingSave(false);
                                                    setMessagePopup('Save was successful!');
                                                    setShowPopup(true);
                                                },

                                                function () {
                                                    setShowLoadingSave(false);
                                                    setMessagePopup('Save was successful!');
                                                    setShowPopup(true);
                                                }
                                            );
                                    }
                                    else {
                                        setShowLoadingSave(false);
                                        setMessagePopup('An error occured!');
                                        setShowPopup(true);
                                    }   
                                },
                                function (response) {
                                    setShowLoadingSave(false);
                                    setMessagePopup('An error occured!');
                                    setShowLoadingSave(false);
                                }
                            );
                }
                else {
                    setShowLoadingSave(false);
                }     
            }
        }
    }

    const dismissAlert = () => {
        setShowPopup(false);
        // if (activityId === '0') {
        //     history.push("/activity/" + stateActivityId + "/" + clientId  + "/" + type);
        // }
    }

    const goBack = () => {
        if (isExternal === "1")
            history.push('/home');
        else
            history.goBack();
    }

//#endregion "Save Logic"
    return (
        <IonHeader mode="ios" className="my-header-list">
            {/* Harbor */}
            {harborIsVisible && harborList() &&
                (<IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Harbor {<span style={{color: "red" }}>*</span>}</IonLabel>
                        <IonSelect value={clientId} placeholder="Select Harbor" interface="action-sheet" mode="ios"
                        onIonChange={e => changeClient(e.detail.value)}>
                        { harborList().map((x:any) => {
                            return <IonSelectOption className="my-select-option" key={x.id} value={x.id}>{x.name}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>)
            }
            {/* Start Date */}
            <IonItem className="my-ion-item" mode="ios">
                <IonLabel mode="ios" className="my-ion-item-label isRequired" position="stacked">{labelStart()} {<span style={{color: "red" }}>*</span>}</IonLabel>
                <IonIcon mode="ios" className="my-person-icon" slot="end" icon={calendarOutline} size="small"></IonIcon>
                <IonDatetime mode="ios" displayFormat={displayFormat}
                        pickerFormat={pickerFormat}
                        value={startDate}
                        onIonChange={e => startDateChange(e)}>
                </IonDatetime>
            </IonItem>
            
            {/* End Date */}
            { endIsVisible &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">{labelEnd()}</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={calendarOutline} size="small"></IonIcon>
                    <IonDatetime mode="ios" displayFormat={displayFormat}
                        pickerFormat={pickerFormat}
                        value={endDate}
                        onIonChange={e => endDateChange(e)}>
                    </IonDatetime>
                </IonItem>
            }
            {/* Staff Person */}
             <IonItem mode="ios" className="my-ion-item"> 
                <IonLabel mode="ios" className="my-ion-item-label" position="stacked">{labelStaffPerson} {<span style={{color: "red" }}>*</span>}</IonLabel>
                <IonIcon mode="ios"  className="my-person-icon" slot="end" icon={personOutline} onClick={pickUser} size="small"></IonIcon>
                <IonLabel mode="ios" className="my-person-label">{selectedUserName}</IonLabel>
            </IonItem>
            
            {/* Activity Type */}
            { (type === '1' || type === '2') && activityTypeListVisible &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Work Type {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={activityType} placeholder="Select activity type" interface="action-sheet" mode="ios"
                        onIonChange={e => setActivityType(e.detail.value)}>
                        {
                            activityTypeList.map((x:any) => {
                                return <IonSelectOption key={x.Text} value={x.Text}>{x.Text}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* GAR Score */}
            { (type === '9') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">GAR Score {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={chevronForwardOutline} onClick={pickGAR} size="small"></IonIcon>
                    <IonInput mode="ios" className={garColorLabel} value={selectedGARName}></IonInput>
                </IonItem>
            }
            {/* Comments */}
            { type !== '7' &&  type !== '9' &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Comments</IonLabel>
                    <IonTextarea mode="ios" value={comments} placeholder="Comments"
                            onIonChange={(e) => setComments(e.detail.value!)}></IonTextarea>
                </IonItem>
            }
            {/* Category */}
            { (type === '1' || type === '3') && categoryListVisible &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Category {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={category} placeholder="Select category" interface="action-sheet" mode="ios"
                        onIonChange={e => setCategory(e.detail.value)}>
                        {
                            categoryList.map((x:any) => {
                                return <IonSelectOption key={x.Text} value={x.Text}>{x.Text}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* Images */}
            { (type === '1' || type === '3' || type === '8') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Images</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={camera} onClick={pickCamera} size="small"></IonIcon>
                    <IonInput mode="ios" value={selectedImagesSummary}></IonInput>
                </IonItem>
            }
            {/* Location */}
            { (type === '1' || type === '3' || type === '5' || type === '6' || type === '8') && locationListVisible &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Location {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={locationA} placeholder="Select location" interface="action-sheet" mode="ios"
                        onIonChange={e => setLocationA(e.detail.value)}>
                        {
                            locationList.map((x:any) => {
                                return <IonSelectOption key={x.Text + x.ClientID.toString()} value={x.Text}>{x.Text}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* Coordinates */}
            { (type === '1' || type === '3' || type === '5'  || type === '6' || type === '8') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Coordinates</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={chevronForwardOutline} onClick={pickCoordinates} size="small"></IonIcon>
                    <IonInput mode="ios" value={FixSelectedCoordinates()}></IonInput>
                </IonItem>
            }
            {/* weather Source */}
            { (type === '3' || type === '7') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Weather Source</IonLabel>
                    <IonInput mode="ios" value={weatherSource} placeholder="Weather source"
                        onIonChange={(e) => changeWeatherSource(e.detail.value!)}></IonInput>
                </IonItem>
            }
            {/* weather */}
            { (type === '3' || type === '7') && 
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked" aria-disabled={false}>Weather {<span style={{color: "red" }}>*</span>} </IonLabel>
                    <IonSelect value={weatherId} className = {isDisabled ? "my-ion-select-disabled": ""} placeholder="Select weather" interface="action-sheet" mode="ios"
                        onIonChange={e => setWeatherId(e.detail.value)}>
                        {
                            weatherList().map((x:any) => {
                                return <IonSelectOption key={x.WeatherID} value={x.WeatherID}>{x.Description}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* wind */}
            { (type === '3' || type === '7') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Wind {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={windId} className = {isDisabled ? "my-ion-select-disabled": ""} placeholder="Select wind" interface="action-sheet" mode="ios"
                        onIonChange={e => setWindId(e.detail.value)}>
                        {
                            windsList().map((x:any) => {
                                return <IonSelectOption key={x.WindID} value={x.WindID}>{x.Description}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* seas */}
            { (type === '3' || type === '7') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Seas {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={seasId} className = {isDisabled ? "my-ion-select-disabled": ""} placeholder="Select sea" interface="action-sheet" mode="ios"
                        onIonChange={e => setSeasId(e.detail.value)}>
                        {
                            seasList().map((x:any) => {
                                return <IonSelectOption key={x.SeasID} value={x.SeasID}>{x.Description}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* tide */}
            { (type === '3' || type === '7') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Tide</IonLabel>
                    <IonInput mode="ios" className = {isDisabled ? "my-ion-select-disabled": ""} value={tide} placeholder="Tide"
                                onIonChange={(e) => setTide(e.detail.value!)}></IonInput>
                </IonItem>
            }
            {/* vessel */}
            { (type === '3' || type === '5' || type === '6' || type === '8') &&  //(boatList.length > 0) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Vessel {<span style={{color: "red" }}>*</span>} </IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={boatOutline} onClick={pickBoat} size="small"></IonIcon>
                    <IonLabel mode="ios" className="my-person-label">{selectedBoatName}</IonLabel>
                </IonItem>
            }
            {/* vessel length*/}
            { (type === '8' && boatIds.length === 1) && 
                <IonItem mode="ios" className="my-ion-item">
                     <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Vessel length</IonLabel>
                     <IonInput mode="ios" value={addedVesselLength} placeholder="Add Vessel length"
                        onIonChange={(e) => setAddedVesselLength(Number(e.detail.value!))}></IonInput>
                </IonItem>
            }
            {/* vehicle */}
            { (type === '3' || type === '6') && //(vehicleList.length > 0) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Vehicle</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={carOutline} onClick={pickVehicle} size="small"></IonIcon>
                    <IonLabel mode="ios" className="my-person-label">{selectedVehicleName}</IonLabel>
                </IonItem>
            }
            {/* person */}
            { (type === '3' || type === '6') && //(personList.length > 0) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Person</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={personOutline} onClick={pickPerson} size="small"></IonIcon>
                    <IonLabel mode="ios" className="my-person-label">{selectedPersonName}</IonLabel>
                </IonItem>
            }
            {/* person list*/}
            { (type === '3' || type === '6') &&
                personIds.map((item: ILocalIdentifierPerson) => {
                    return ( 
                        <IonItem mode="ios" className="my-ion-item-inside" key={item.ID}>
                            <IonLabel className="ion-text-wrap" mode="ios" position="fixed">{item.Name}</IonLabel>
                            <IonSelect slot="end" value={item.ActivityLogRoleID} placeholder="Select role" 
                                    interface="action-sheet" mode="ios" onIonChange={e => changeActivityLogRoleID(e.detail.value, item)}>
                                {
                                    activityLogRoleList().map((x:any) => {
                                        return <IonSelectOption key={x.ActivityLogRoleID} value={x.ActivityLogRoleID}>{x.Description}</IonSelectOption>
                                    })
                                }
                    </IonSelect>
                        </IonItem>
                    )
                })
            }
            {/* Custom final disposition */}
            { (type === '3') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Custom final disposition</IonLabel>
                    <IonSelect value={incidentDispositionId} placeholder="Select final disposition" interface="action-sheet" mode="ios"
                        onIonChange={e => setIncidentDispositionId(e.detail.value)}>
                        {
                            incidentDispositionList().map((x:any) => {
                                return <IonSelectOption key={x.IncidentDispositionID} value={x.IncidentDispositionID}>{x.Description}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* Approved */}
            { (type === '3') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label">Approved</IonLabel>
                    <IonToggle mode="ios" checked={approved} color="success" onIonChange={e => changeApproved(e)} />
                </IonItem>
            }
            {/*Approved By*/}
            { (type === '3' && approved) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Approved By</IonLabel>
                    {/* <IonLabel mode="ios" className="my-person-label">{approvedBy}</IonLabel> */}
                    <IonInput mode="ios" readonly value={approvedBy}></IonInput>
                </IonItem>
            }
            {/* Equipment */}
            { (type === '4' && equipmentList.length > 0) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Equipment {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={equipmentId} placeholder="Select equipment" interface="action-sheet" mode="ios"
                        onIonChange={e => changeEquipment(e)}>
                        {
                            equipmentList.map((x:any) => {
                                return <IonSelectOption key={x.EquipmentID} value={x.EquipmentID}>{x.EquipmentName}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* Equipment status */}
            { (type === '4') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Equipment status {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonSelect value={equipmentStatusId} placeholder="Select equipment status" mode="ios" interface="action-sheet"
                        onIonChange={e => setEquipmentStatusId(e.detail.value)}>
                        {
                            equipmentStatusList().map((x:any) => {
                                return <IonSelectOption key={x.EquipmentStatusID} value={x.EquipmentStatusID}>{x.Description}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* Pre Inspection */}
            { (type === '4' && selectedPrePostInspections.length > 0) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Pre Inspection {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={chevronForwardOutline} onClick={pickPreInspection} size="small"></IonIcon>
                    <IonLabel mode="ios" className="my-person-label">{preInspectionText}</IonLabel>
                </IonItem>
            }
            {/* Post Inspection */}
            { (type === '4' && selectedPrePostInspections.length > 0) &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Post Inspection</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={chevronForwardOutline} onClick={pickPostInspection} size="small"></IonIcon>
                    <IonLabel mode="ios" className="my-person-label">{postInspectionText}</IonLabel>
                </IonItem>
            }
            {/* Quantity */}
            { (type === '5') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Quantity {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonInput mode="ios" value={quantity} placeholder="Quantity"
                                onIonChange={(e) => setQuantity(Number(e.detail.value!))}></IonInput>
                </IonItem>
            }
            {/* Ticket */}
            { (type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Ticket # {<span style={{color: "red" }}>*</span>}</IonLabel>
                    <IonInput mode="ios" value={ticket} placeholder="Ticket #"
                        onIonChange={(e) => setTicket(e.detail.value!)}></IonInput>
                </IonItem>
            }
            {/* IsPrivate */}
            { (type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label">Private</IonLabel>
                    <IonToggle mode="ios" checked={isPrivate} color="success" onIonChange={e => setIsPrivate(e.detail.checked)} />
                </IonItem>
            }
            {/* Offenses */}
            {(type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                   <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Offense {<span style={{color: "red" }}>*</span>}</IonLabel>
                   <IonIcon mode="ios" className="my-person-icon" slot="end" icon={arrowForward} onClick={pickOffense} size="small"></IonIcon>
                   <IonLabel mode="ios" className="my-person-label">{selectedOffenseName}</IonLabel>
                </IonItem>
            }
            {/* Warning */}
            { (type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label">Warning</IonLabel>
                    <IonToggle mode="ios" checked={warning} color="success" onIonChange={e => changeWarning(e)} />
                </IonItem>
            }
            {/* Fee */}
            { (type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Fine</IonLabel>
                    <IonInput mode="ios" value={fee} placeholder="Fine" onIonChange={(e) => setFee(e.detail.value!)} ></IonInput>
                </IonItem>
            }
            {/* Delivery Methods */}
            { (type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Delivery Method</IonLabel>
                    <IonSelect value={deliveryMethodId} placeholder="Select delivery methid" interface="action-sheet" mode="ios"
                        onIonChange={e => setDeliveryMethodId(e.detail.value)}>
                        {
                            deliveryMethodsList().map((x:IDeliveryMethodInfo) => {
                                return <IonSelectOption key={x.DeliveryMethodID} value={x.DeliveryMethodID}>{x.Description}</IonSelectOption>
                            })
                        }
                    </IonSelect>
                </IonItem>
            }
            {/* Delivery date */}
            { (type === '6') &&
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Delivery date</IonLabel>
                    <IonIcon mode="ios" className="my-person-icon" slot="end" icon={calendarOutline} size="small"></IonIcon>
                    <IonDatetime mode="ios" displayFormat= {displayFormat}
                        pickerFormat={pickerFormat}
                        value={deliveryDate}
                        onIonChange={e => deliveryDateChange(e)}>
                    </IonDatetime>
                </IonItem>
            }
            {/* SafetyCheck */}
            {(type === '8') &&
                safetyCheckListFiltered().map((item) => {
                    return (
                        <IonItem mode="ios" className="my-ion-item" key={item.SafetyCheckID}>
                            <IonLabel className="ion-text-wrap" mode="ios" position="stacked">
                                <p><IonText color="black" mode="ios"><b>{item.Description}</b></IonText> {item.Comments}</p></IonLabel>
                            <IonSegment mode="ios" value = {item.value} className="my-segment"
                                onIonChange={e => selectSafetyCheckItemValue(e.detail.value, item.SafetyCheckID)}>
                                <IonSegmentButton mode="ios" className="my-segment-button" value="1" disabled={item.disablePass}>
                                    <IonLabel className="myLabel_pass" mode="ios">Pass</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segment-button" value="0" disabled={item.disableFailed}>
                                    <IonLabel mode="ios">Failed</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segment-button" value="2" disabled= {item.disableNA}>
                                    <IonLabel mode="ios" className="myLabel_NA">N/A</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                           
                        </IonItem>
                    )
                })
            }
            {/* On Watch List */}
            <IonItem mode="ios" className="my-ion-item">
                <IonLabel mode="ios" className="my-ion-item-label">On Watch List</IonLabel>
                <IonToggle mode="ios" checked={pinned} color="success" onIonChange={e => setPinned(e.detail.checked)} />
            </IonItem>
            
            {/* buttons area */}
            <IonButton mode="ios" class="my-main-button" onClick={save}>Save</IonButton>
            <IonButton mode="ios" class="my-cancel-button" fill="outline" onClick={goBack}>Cancel</IonButton>

            {/* interaction area */}
            <IonLoading mode="ios"
                cssClass='my-loading'
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={messageLoading}
            />
            <IonLoading mode="ios"
                cssClass='my-loading'
                isOpen={showLoadingSave}
                onDidDismiss={() => setShowLoadingSave(false)}
                message={"Saving data..."}
            />
            <IonAlert mode="ios"
                isOpen={showPopup}
                onDidDismiss={() => setShowPopup(false)}
                cssClass='my-custom-class'
                header={'Info'}
                subHeader={''}
                message={messagePopup}
                buttons= {[
                    { text: 'OK', handler: () => { dismissAlert() } }
                ]}
            />
            <IonToast mode="ios"
                isOpen={showToast}
                onDidDismiss={() => setShowToast(false)}
                message = {toastMessage}
                duration={3000}
                position="top"
                color = "warning"
                header = "Warning"
            />

            {/* modal area */}
            <IonModal mode="ios" isOpen={personSelectionVisibility} cssClass="my-modal" backdropDismiss={false}>
               <IonList mode="ios">
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Person</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchPerson} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchPerson} placeholder="Search person"
                                            onIonChange={e => setSearchPerson(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonButton onClick={showPersonAdd}>Add person</IonButton>
                    </IonItem>
                    { type === "3" &&
                        <>
                            <IonRadioGroup>
                                {searchPersonList.map((x:any) =>
                                    {
                                        return  (
                                            <IonItem mode="ios" className="my-person-radio" key={x.Id}>
                                                <IonLabel mode="ios">{x.FullName}</IonLabel>
                                                <IonCheckbox mode="ios" slot="end" value={x.Id} checked={personIds.map(x => x.ID).includes(x.Id)}
                                                            onIonChange={e => personSelect(e, x.FullName)} />
                                            </IonItem>
                                        )
                                    })
                                }
                            </IonRadioGroup>
                            <IonButton mode="ios" class="my-main-button" onClick={closeSearchPerson}>Select</IonButton>
                        </>
                    }
                    { type !== "3" &&
                        <IonRadioGroup value={singlePersonId} onIonChange={e => singlePersonIdSelect(e)}>
                            {searchPersonList.map((x:any) => 
                                {
                                    return (
                                        <IonItem className="my-person-radio" key={x.Id}>
                                            <IonLabel>{x.FullName}</IonLabel>
                                            <IonRadio slot="end" value={x.Id} />
                                        </IonItem>
                                    )
                                })
                            }
                        </IonRadioGroup>
                    }     
                </IonList>
            </IonModal>

            <IonModal mode="ios" isOpen={personAddVisibility} cssClass="my-modal-big" backdropDismiss={false}>
                <IonContent scrollEvents={true} scrollY={true}>
                    <IonList mode="ios">
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">First Name</IonLabel>
                            <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeAddPerson} size="small"></IonIcon>
                            <IonInput mode="ios" value={personFirstName} placeholder="Add First Name"
                                    onIonChange={(e) => setPersonFirstName(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Last Name</IonLabel>
                            <IonInput mode="ios" value={personLastName} placeholder="Add Last Name"
                                    onIonChange={(e) => setPersonLastName(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem className="my-ion-item" mode="ios">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Birth date</IonLabel>
                            <IonIcon mode="ios" className="my-person-icon" slot="end" icon={calendarOutline} size="small"></IonIcon>
                            <IonDatetime mode="ios" className="my-input-datetime" 
                                    displayFormat={pickerFormatDataOnly}
                                    pickerFormat={pickerFormatDataOnly}
                                    value={personBirthDate}
                                    onIonChange={e => birthDateChange(e)}>
                            </IonDatetime>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Mailing Street</IonLabel>
                            <IonInput mode="ios" value={personMailingStreet} placeholder="Add mailing street"
                                    onIonChange={(e) => setPersonMailingStreet(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Mailing State</IonLabel>
                            <IonInput mode="ios" value={personMailingState} placeholder="Add mailing state"
                                    onIonChange={(e) => setPersonMailingState(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Mailing City</IonLabel>
                            <IonInput mode="ios" value={personMailingCity} placeholder="Add mailing city"
                                    onIonChange={(e) => setPersonMailingCity(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Mailing Zip code</IonLabel>
                            <IonInput mode="ios" value={personMailingZipCode} placeholder="Add mailing zip code"
                                    onIonChange={(e) => setPersonMailingZipCode(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Email</IonLabel>
                            <IonInput mode="ios" value={personEmail} placeholder="Add email"
                                    onIonChange={(e) => setPersonEmail(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Primary phone</IonLabel>
                            <IonInput mode="ios" value={personPrimaryPhone} placeholder="Add primary phone"
                                    onIonChange={(e) => setPersonPrimaryPhone(e.detail.value!)}></IonInput>
                        </IonItem>   
                    </IonList>
                    <IonButton mode="ios" class="my-main-button-fixed" onClick={addPerson}>Add person</IonButton>
                </IonContent>
            </IonModal>

            <IonModal mode="ios" isOpen={vesselSelectionVisibility} cssClass="my-modal" backdropDismiss={false}>
                <IonList mode="ios">
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Vessel</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchVessel} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchVessel} placeholder="Search vessel"
                                            onIonChange={e => setSearchVessel(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonButton onClick={showVesselAdd}>
                            Add vessel
                        </IonButton>
                    </IonItem>
                    { type === "3" &&
                        <>
                            <IonRadioGroup>
                                {searchVesselList.map((x:any) =>
                                    {
                                        return  (
                                            <IonItem mode="ios" className="my-person-radio" key={x.Id}>
                                                <IonLabel mode="ios">{x.FullName}</IonLabel>
                                                <IonCheckbox mode="ios" slot="end" value={x.Id} checked = {boatIds.map(x => x.ID).includes(x.Id)}
                                                            onIonChange={e => vesselSelect(e, x.IsReg)} />
                                            </IonItem>
                                        )
                                    })
                                }
                            </IonRadioGroup>
                            <IonButton mode="ios" class="my-main-button" onClick={closeSearchVessel}>Select</IonButton>
                        </>
                    }
                    { type !== "3" &&
                        <IonRadioGroup value={singleVesselId} onIonChange={e => singleVesselIdSelect(e)}>
                            {searchVesselList.map((x:any) => 
                                {
                                    return (
                                        <IonItem className="my-person-radio" key={x.Id}>
                                            <IonLabel>{x.FullName}</IonLabel>
                                            <IonRadio slot="end" value={x.Id} />
                                        </IonItem>
                                    )
                                })
                            }
                        </IonRadioGroup>
                    }     
                </IonList>
            </IonModal>

            <IonModal mode="ios" isOpen={vesselAddVisibility} cssClass="my-modal" backdropDismiss={false}>
                <IonContent fullscreen>
                    <IonList mode="ios">
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Add Vessel</IonLabel>
                            <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeAddVessel} size="small"></IonIcon>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Reg/Doc #</IonLabel>
                            <IonInput mode="ios" value={vesselRegDoc} placeholder="Add Reg/Doc"
                                    onIonChange={(e) => setVesselRegDoc(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Boat Name</IonLabel>
                            <IonInput mode="ios" value={vesselBoatName} placeholder="Add Boat name"
                                    onIonChange={(e) => setVesselBoatName(e.detail.value!)}></IonInput>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Length</IonLabel>
                            <IonInput inputmode="decimal" mode="ios" value={vesselLength} placeholder="Add length"
                                    onIonChange={(e) => changeVesselLength(e)}></IonInput>
                        </IonItem>
                        {/* {warningLengthVisibility && 
                            <IonItem mode="ios" className="my-ion-item-red">
                                <IonLabel mode="ios" className="my-ion-item-label-red">The length should be greater than 0.</IonLabel>
                            </IonItem> 
                        } */}
                    </IonList>
                    <IonButton mode="ios" class="my-main-button-fixed" onClick={addVessel}>Add vessel</IonButton>
                </IonContent>
            </IonModal>

            <IonModal mode="ios" isOpen={vehicleSelectionVisibility} cssClass="my-modal" backdropDismiss={false}>
                <IonList mode="ios">      
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Vehicle</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchVehicle} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchVehicle} placeholder="Search vessel" 
                                            onIonChange={e => setSearchVehicle(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonButton onClick={showVehicleAdd}>
                            Add vehicle
                        </IonButton>
                    </IonItem>
                    { type === "3" &&
                        <>
                            <IonRadioGroup>
                                {searchVehicleList.map((x:any) => 
                                    {
                                        return (
                                            <IonItem mode="ios" className="my-person-radio" key={x.Id}>
                                                <IonLabel mode="ios">{x.FullName}</IonLabel>
                                                <IonCheckbox mode="ios" slot="end" value={x.Id} checked = {vehicleIds.includes(x.Id)} onIonChange={e => vehicleSelect(e)} />
                                            </IonItem>
                                        )
                                    })
                                }
                            </IonRadioGroup>
                            <IonButton mode="ios" class="my-main-button" onClick={closeSearchVehicle}>Select</IonButton> 
                        </>
                    }  
                    { type !== "3" &&
                        <IonRadioGroup value={singleVehicleId} onIonChange={e => singleVehicleIdSelect(e)}>
                            {searchVehicleList.map((x:any) => 
                                {
                                    return (
                                        <IonItem className="my-person-radio" key={x.Id}>
                                            <IonLabel>{x.FullName}</IonLabel>
                                            <IonRadio slot="end" value={x.Id} />
                                        </IonItem>
                                    )
                                })
                            }
                        </IonRadioGroup>
                    } 
                </IonList>
            </IonModal> 

            <IonModal mode="ios" isOpen={vehicleAddVisibility} cssClass="my-modal" backdropDismiss={false}>
                <IonList mode="ios">
                    <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Add Vehicle</IonLabel>
                            <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeAddVehicle} size="small"></IonIcon>
                    </IonItem>
                    <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">License plate</IonLabel>
                            <IonInput mode="ios" value={vehicleLicensePlate} placeholder="Add License plate"
                                    onIonChange={(e) => setVehicleLicensePlate(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonButton mode="ios" class="my-main-button" onClick={addVehicle}>Add vessel</IonButton>
                </IonList>
            </IonModal>
                    
            <IonModal mode="ios" isOpen={offenseSelectionVisibility} cssClass="my-modal-big" backdropDismiss={false}>
               <IonList mode="ios">
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Offense</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchOffense} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchOffense} placeholder="Search offense"
                                            onIonChange={e => setSearchOffense(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonRadioGroup>
                        {offenseSelectionVisibility && searchOffenseList.map((x:any) =>
                            {
                                return  (
                                    <IonItem mode="ios" className="my-person-radio" key={x.ActivityTypeViolationID + x.FullName}>
                                        <IonLabel mode="ios">{x.FullName}</IonLabel>
                                        <IonCheckbox mode="ios" slot="end" value={x.ActivityTypeViolationID} 
                                                    checked = {offenses.filter((o) =>  
                                                                    (x.ActivityTypeViolationID && o.ActivityLogViolationID?.toString() === x.ActivityTypeViolationID?.toString())
                                                                    || (x.ActivityTypeViolationID == null && o.ViolationTypeID?.toString() === x.ID?.toString())).length > 0}
                                                    onIonChange={e => offenseSelect(e, x)} />
                                    </IonItem>
                                )
                            })
                        }
                    </IonRadioGroup>
                    <IonItem>
                        <IonButton onClick={showOffenseAdd}>Other</IonButton>
                    </IonItem>
                    <IonButton mode="ios" class="my-main-button" onClick={closeSearchOffense}>Select</IonButton>
                </IonList>
            </IonModal>
            
            <IonModal mode="ios" isOpen={offenseAddVisibility} cssClass="my-modal" backdropDismiss={false}>
                <IonContent fullscreen>
                    <IonList mode="ios">
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Add Offense</IonLabel>
                            <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeAddOffense} size="small"></IonIcon>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Description</IonLabel>
                            <IonTextarea mode="ios" value={offenseDescription} placeholder="Add Description"
                                    onIonChange={(e) => setOffenseDescription(e.detail.value!)}></IonTextarea>
                        </IonItem>
                        <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Fine</IonLabel>
                            <IonInput inputmode="decimal" mode="ios" value={offenseFine} placeholder="Add fee"
                                    onIonChange={(e) => setOffenseFine(Number(e.detail.value))}></IonInput>
                        </IonItem>
                    </IonList>
                    <IonButton mode="ios" class="my-main-button-fixed" onClick={addOffense}>Add offense</IonButton>
                </IonContent>
            </IonModal>

            <IonModal mode="ios" isOpen={preInspectionVisibility} backdropDismiss={false}>
                <IonList mode="ios">
                    <IonHeader mode="ios">
                        <IonGrid className="my_toolbar_4">
                            <IonRow>
                                <IonCol size="1" className="ion-align-self-left">
                                    <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast"
                                                   onClick = {(e) => backPrePostInspection()}>
                                            <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                                    </IonButton>
                                </IonCol>
                                <IonCol size="5" className="ion-align-self-center">
                                    <IonLabel mode="ios" className="my-label-title">Pre Inspection</IonLabel>
                                </IonCol>
                                <IonCol size="6"></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    {selectedPrePostInspections.map((x:any) => {
                        return  (
                            <IonItem mode="ios" className="my-ion-item" key={x.EquipmentInspectionPointID}>
                                <IonLabel mode="ios" position="fixed" className="my-ion-item-label-insp">{x.Description}</IonLabel>
                                {(x.DataType === "boolean") &&
                                    <IonCheckbox mode="ios" slot="end" value={x.EquipmentInspectionPointID} checked = {x.ValueBoolean ?? false }
                                            onIonChange={e => {inspectionPointChange(e,"boolean", x.EquipmentInspectionPointID, true)}} />
                                }
                                {(x.DataType === "decimal2") &&
                                    <IonInput inputmode="decimal"  mode="ios" className="my-ion-item-input-insp" value={x.ValueDecimal2} placeholder="Add" key={x.EquipmentInspectionPointID}
                                            onIonChange={e => {inspectionPointChange(e,"decimal2", x.EquipmentInspectionPointID, true)}}></IonInput>
                                }
                            </IonItem>
                        )})
                    }
                    <IonButton mode="ios" class="my-main-button" onClick={savePrePostInspection}>Save Inspection Data</IonButton>
                </IonList>
            </IonModal>

            <IonModal mode="ios" isOpen={postInspectionVisibility} backdropDismiss={false}>
                <IonList mode="ios">
                    <IonHeader mode="ios">
                        <IonGrid className="my_toolbar_4">
                            <IonRow>
                                <IonCol size="1" className="ion-align-self-left">
                                    <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast"
                                                   onClick = {(e) => backPrePostInspection()}>
                                            <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                                    </IonButton>
                                </IonCol>
                                <IonCol size="5" className="ion-align-self-center">
                                    <IonLabel mode="ios" className="my-label-title">Post Inspection</IonLabel>
                                </IonCol>
                                <IonCol size="6"></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    {selectedPrePostInspections.map((x:any) => {
                        return  (
                            <IonItem mode="ios" className="my-ion-item" key={x.EquipmentInspectionPointID}>
                                <IonLabel mode="ios" position="fixed" className="my-ion-item-label-insp">{x.Description}</IonLabel>
                                {(x.DataType === "boolean") &&
                                    <IonCheckbox mode="ios" slot="end" value={x.EquipmentInspectionPointID} checked = {x.ValueBoolean ?? false }
                                            onIonChange={e => {inspectionPointChange(e,"boolean", x.EquipmentInspectionPointID, false)}} />
                                }
                                {(x.DataType === "decimal2") &&
                                    <IonInput inputmode="decimal"  mode="ios" className="my-ion-item-input-insp" value={x.ValueDecimal2} placeholder="Add" 
                                            key={x.EquipmentInspectionPointID}
                                            onIonChange={e => {inspectionPointChange(e,"decimal2", x.EquipmentInspectionPointID, false)}}></IonInput>
                                }
                            </IonItem>
                        )})
                    }
                    <IonButton mode="ios" class="my-main-button" onClick={savePrePostInspection}>Save Inspection Data</IonButton>
                </IonList>
            </IonModal>
            
            <IonModal mode="ios" isOpen={garSelectionVisibility} cssClass="my-modal-big" backdropDismiss={false}>
                <IonContent>
                    <IonList mode="ios">
                        <IonHeader mode="ios">
                            <IonGrid className={(supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity < 24)
                                                    ? "my-toolbar-green"
                                                    : ((supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity < 45)
                                                        ? "my-toolbar-yellow"
                                                        : "my-toolbar-red") }>
                                <IonRow>
                                    <IonCol size="1" className="ion-align-self-left">
                                        <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast"
                                                   onClick = {(e) => setGarSelectionVisibility(false)}>
                                            <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                                        </IonButton>
                                    </IonCol>
                                    <IonCol size="5" className="ion-align-self-center">
                                        <IonLabel mode="ios" className="my-label-title">GAR Score</IonLabel>
                                    </IonCol>
                                    <IonCol size="6"></IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonHeader>
                        {/* Supervision */}
                        {supervision &&
                            <>
                                <IonItem mode="ios" className="my-ion-item">
                                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Supervision</IonLabel>
                                        <IonText mode="ios" className="my-ion-textarea">
                                            How closely do you want to supervise the crew/unit?
                                            The higher the risk the more a supervisor must focus on observing and checking.
                                        </IonText>
                                    </IonItem>
                                <IonSegment mode="ios" className="my-segmentlist" value={supervision.toString()} onIonChange={e => setGARItem(e, "supervision")}>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="1">
                                    <IonLabel mode="ios">1</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="2">
                                    <IonLabel mode="ios">2</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="3">
                                    <IonLabel mode="ios">3</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="4">
                                    <IonLabel mode="ios">4</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="5">
                                    <IonLabel mode="ios">5</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="6">
                                    <IonLabel mode="ios">6</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="7">
                                    <IonLabel mode="ios">7</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="8">
                                    <IonLabel mode="ios">8</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="9">
                                    <IonLabel mode="ios">9</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="10">
                                    <IonLabel mode="ios">10</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            </>
                        }
                        {/* Planning */}
                        {planning &&
                            <>
                                <IonItem mode="ios" className="my-ion-item">
                                <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Planning</IonLabel>
                                <IonText mode="ios" className="my-ion-textarea">
                                    How much information is available, how clear is it, how much time is available to plan/execute the mission?
                                </IonText>
                            </IonItem>
                                <IonSegment mode="ios" className="my-segmentlist" value={planning.toString()} onIonChange={e => setGARItem(e, "planning")}>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="1">
                                    <IonLabel mode="ios">1</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="2">
                                    <IonLabel mode="ios">2</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="3">
                                    <IonLabel mode="ios">3</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="4">
                                    <IonLabel mode="ios">4</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="5">
                                    <IonLabel mode="ios">5</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="6">
                                    <IonLabel mode="ios">6</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="7">
                                    <IonLabel mode="ios">7</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="8">
                                    <IonLabel mode="ios">8</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="9">
                                    <IonLabel mode="ios">9</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="10">
                                    <IonLabel mode="ios">10</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            </>
                        }
                        {/* CrewSelection */}
                        {crewSelection &&
                            <>
                                <IonItem mode="ios" className="my-ion-item">
                                <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Crew Selection</IonLabel>
                                <IonText mode="ios" className="my-ion-textarea">
                                Consider the experience of the crews performing the mission. If individuals are replaced during the
                                mission, assess their experience level and ensure proper turnover.
                                </IonText>
                            </IonItem>
                                <IonSegment mode="ios" className="my-segmentlist" value={crewSelection.toString()} onIonChange={e => setGARItem(e, "crewSelection")}>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="1">
                                    <IonLabel mode="ios">1</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="2">
                                    <IonLabel mode="ios">2</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="3">
                                    <IonLabel mode="ios">3</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="4">
                                    <IonLabel mode="ios">4</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="5">
                                    <IonLabel mode="ios">5</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="6">
                                    <IonLabel mode="ios">6</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="7">
                                    <IonLabel mode="ios">7</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="8">
                                    <IonLabel mode="ios">8</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="9">
                                    <IonLabel mode="ios">9</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="10">
                                    <IonLabel mode="ios">10</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            </>
                        }
                        {/* CrewEndurance */}
                        {crewEndurance &&
                            <>
                                <IonItem mode="ios" className="my-ion-item">
                                <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Crew Endurance</IonLabel>
                                <IonText mode="ios" className="my-ion-textarea">Refer to published crew fatigue standards</IonText>
                            </IonItem>
                                <IonSegment mode="ios" className="my-segmentlist" value={crewEndurance.toString()}  onIonChange={e => setGARItem(e, "crewEndurance")}>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="1">
                                    <IonLabel mode="ios">1</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="2">
                                    <IonLabel mode="ios">2</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="3">
                                    <IonLabel mode="ios">3</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="4">
                                    <IonLabel mode="ios">4</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="5">
                                    <IonLabel mode="ios">5</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="6">
                                    <IonLabel mode="ios">6</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="7">
                                    <IonLabel mode="ios">7</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="8">
                                    <IonLabel mode="ios">8</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="9">
                                    <IonLabel mode="ios">9</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="10">
                                    <IonLabel mode="ios">10</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            </>
                        }
                        {/* Weather */}
                        {garWeather &&
                            <>
                                <IonItem mode="ios" className="my-ion-item">
                                <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Weather</IonLabel>
                                <IonText mode="ios" className="my-ion-textarea">
                                    Environment should include all contributing factors; time of day, lighting atmospheric/oceanic conditions,
                                    chemical hazards, proximity to other external and geographic hazards/barriers, among other factors.
                                </IonText>
                            </IonItem>
                                <IonSegment mode="ios" className="my-segmentlist" value={garWeather.toString()}  onIonChange={e => setGARItem(e, "garWeather")}>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="1">
                                    <IonLabel mode="ios">1</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="2">
                                    <IonLabel mode="ios">2</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="3">
                                    <IonLabel mode="ios">3</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button" value="4">
                                    <IonLabel mode="ios">4</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="5">
                                    <IonLabel mode="ios">5</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="6">
                                    <IonLabel mode="ios">6</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="7">
                                    <IonLabel mode="ios">7</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="8">
                                    <IonLabel mode="ios">8</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="9">
                                    <IonLabel mode="ios">9</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="10">
                                    <IonLabel mode="ios">10</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                            </>
                        }
                        {/* Case Complexity */}
                        {caseComplexity &&
                            <>
                                <IonItem mode="ios" className="my-ion-item">
                            <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Case Complexity</IonLabel>
                            <IonText mode="ios" className="my-ion-textarea">
                                Event or evolution complexity considers both time and resources required to conduct the mission.
                                Generally, the longer the exposure to a hazard, the greater the risk.
                            </IonText>
                        </IonItem>
                                <IonSegment mode="ios" className="my-segmentlist" value={caseComplexity.toString()}  onIonChange={e => setGARItem(e, "caseComplexity")}>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button" value="1">
                                <IonLabel mode="ios">1</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button" value="2">
                                <IonLabel mode="ios">2</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button" value="3">
                                <IonLabel mode="ios">3</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button" value="4">
                                <IonLabel mode="ios">4</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="5">
                                <IonLabel mode="ios">5</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="6">
                                <IonLabel mode="ios">6</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="7">
                                <IonLabel mode="ios">7</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="8">
                                <IonLabel mode="ios">8</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="9">
                                <IonLabel mode="ios">9</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton mode="ios" className="my-segmentlist-button-red" value="10">
                                <IonLabel mode="ios">10</IonLabel>
                            </IonSegmentButton>
                        </IonSegment>
                            </>
                        }
                        { supervision && planning  && crewSelection && crewEndurance && garWeather && caseComplexity &&
                            <>
                                <IonItem mode="ios">
                                    {/* <IonInput className={garColorLabel} defaultValue="Total GAR Score"></IonLabel> */}
                                    <IonInput mode="ios" className={(supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity < 24)
                                                            ? "my-ion-item-green"
                                                            : ((supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity < 45)
                                                                ? "my-ion-item-yellow"
                                                                : "my-ion-item-red")
                                                        }
                                        value={"Total GAR Score " + (supervision + planning + crewSelection + crewEndurance + garWeather + caseComplexity).toString()}></IonInput>
                                </IonItem>
                            </>
                        }
                        <IonButton mode="ios" class="my-main-button" onClick={addGARScore}>Add GAR Score</IonButton>
                    </IonList>
                </IonContent>
            </IonModal>
            
            <IonModal mode="ios" isOpen={mapVisibility} cssClass="my-modal-medium" backdropDismiss={false}>
                <IonList mode="ios">
                    <IonHeader mode="ios">
                        <IonGrid className="my_toolbar_4">
                            <IonRow>
                                <IonCol size="1" className="ion-align-self-left">
                                        <IonButton size="small" fill="clear" className="my-back-button" color="primary-contrast" onClick = {(e) => setMapVisibility(false)}>
                                            <IonIcon icon={chevronBackOutline} color="primary-contrast"/>
                                        </IonButton>
                                    </IonCol>
                                <IonCol size="5" className="ion-align-self-center">
                                    <IonLabel mode="ios" className="my-label-title">{"Coordinates"}</IonLabel>
                                </IonCol>
                                <IonCol size="6"></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonItem mode="ios" className="my-ion-item-map">
                        <MapItemSimple latitude={activityLogLatitude} longitude={activityLogLongitude} onAction={getChangedCoordinates}></MapItemSimple>
                    </IonItem>
                    <IonButton mode="ios" class="my-main-button" onClick = {addCoordinates}>Change</IonButton>
                    <IonButton mode="ios" class="my-cancel-button" fill="outline" onClick = {cancelCoordinates}>Cancel</IonButton>
                </IonList>
            </IonModal>
            
            <IonModal mode="ios" isOpen={imagesVisibility} cssClass="my-modal-medium" backdropDismiss={false}>
                <IonList mode="ios">
                    <IonHeader mode="ios">
                        <IonGrid className="my_toolbar_4">
                            <IonRow>
                                <IonCol size="1" className="ion-align-self-left">
                                    <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast"
                                                            onClick = {(e) => setImagesVisibility(false)}>
                                        <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                                    </IonButton>
                                </IonCol>
                                <IonCol size="5" className="ion-align-self-center">
                                    <IonLabel mode="ios" className="my-label-title">{"Images"}</IonLabel>
                                </IonCol>
                                <IonCol size="6"></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonFab className="my-pictures-fab" horizontal="center" slot="fixed">
                        <IonFabButton mode="ios" onClick={() => onPhotoTaken(_token, stateActivityId, _clientId)}>
                            <IonIcon mode="ios" icon={camera}></IonIcon>
                        </IonFabButton>
                    </IonFab> 
                    <IonGrid className="my-pictures-grid">
                        <IonRow>
                            { images.map((photo, index) => (
                                <IonCol size="4" key={index}>
                                    <IonImg src={photo.webviewPath} onClick = {e => enlargeImage(photo)} />
                                    <IonIcon mode="ios" icon={trashOutline} color="primary-contrast" size="small" 
                                             onClick={ e => removeImage(photo)}/>
                                </IonCol>
                            ))}
                        </IonRow>
                    </IonGrid>
                    <IonButton mode="ios" class="my-main-button-pictures" onClick ={saveImages}>Add Photos</IonButton>
                </IonList>
            </IonModal>
            
            <IonModal mode="ios" isOpen={fullImageVisibility} cssClass="my-modal-medium" backdropDismiss={false}>
                <IonHeader mode="ios">
                        <IonGrid className="my_toolbar_4">
                            <IonRow>
                                <IonCol size="1" className="ion-align-self-left">
                                    <IonButton mode="ios" size="small" fill="clear" className="my-back-button" color="primary-contrast"
                                                            onClick = {(e) => setFullImageVisibility(false)}>
                                        <IonIcon mode="ios" icon={chevronBackOutline} color="primary-contrast"/>
                                    </IonButton>
                                </IonCol>
                                <IonCol size="5" className="ion-align-self-center">
                                    <IonLabel mode="ios" className="my-label-title">{"Full Image"}</IonLabel>
                                </IonCol>
                                <IonCol size="6"></IonCol>
                            </IonRow>
                        </IonGrid>
                </IonHeader>
                <IonGrid className="my-fullpicture">
                    <IonRow>
                        <IonCol size="12">
                            {fullPhoto &&
                                <IonImg src={fullPhoto.webviewPath} />
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonModal>
        
            <IonModal mode="ios" isOpen={userSelectionVisibility} cssClass="my-modal" backdropDismiss={false}>
                <IonList mode="ios">                
                    <IonItem mode="ios" className="my-ion-item">
                        <IonLabel mode="ios" className="my-ion-item-label" position="stacked">Staff Person</IonLabel>
                        <IonIcon mode="ios" className="my-person-close" slot="end" icon={closeOutline} onClick={closeSearchUser} size="small"></IonIcon>
                        <IonInput mode="ios" value={searchUser} placeholder="Search staff person" 
                                                    onIonChange={e => setSearchUser(e.detail.value!)}></IonInput>
                    </IonItem>
                    {type === "3" &&
                        <>
                            <IonRadioGroup>
                                {searchUserList.map((x:any) =>
                                    {
                                        return  (
                                            <IonItem mode="ios" className="my-person-radio" key={x.Id}>
                                                <IonLabel mode="ios">{x.FullName}</IonLabel>
                                                <IonCheckbox mode="ios" slot="end" value={x.Id} checked={userIds.includes(x.Id)}
                                                            onIonChange={e => userSelect(e)} />
                                            </IonItem>
                                        )
                                    })
                                }
                            </IonRadioGroup>
                            <IonButton mode="ios" class="my-main-button" onClick={closeSearchUser}>Select</IonButton> 
                        </>
                    } 
                    { type !== "3" &&
                        <IonRadioGroup value={singleUserId} onIonChange={e => singleUserIdSelect(e)}>
                            {searchUserList.map((x:any) => 
                                {
                                    return (
                                        <IonItem className="my-person-radio" key={x.Id}>
                                            <IonLabel>{x.FullName}</IonLabel>
                                            <IonRadio slot="end" value={x.Id} />
                                        </IonItem>
                                    )
                                })
                            }
                        </IonRadioGroup>
                    }     
                </IonList>
            </IonModal>
        
        </IonHeader>
    );
};

export default AddEditActivityItem;

